/* eslint-disable */
import Long from 'long';
import { CAPCheckList } from './VengarCAP';
import _m0 from 'protobufjs/minimal';
export const protobufPackage = 'vengar.protobuffer';
export var VByteOperationType;
(function (VByteOperationType) {
    VByteOperationType[VByteOperationType["UNKNOWN_OPERATION"] = 0] = "UNKNOWN_OPERATION";
    VByteOperationType[VByteOperationType["AND"] = 1] = "AND";
    VByteOperationType[VByteOperationType["NOT"] = 2] = "NOT";
    VByteOperationType[VByteOperationType["OR"] = 3] = "OR";
    VByteOperationType[VByteOperationType["XOR"] = 4] = "XOR";
    VByteOperationType[VByteOperationType["SUB"] = 5] = "SUB";
    VByteOperationType[VByteOperationType["SWAP"] = 6] = "SWAP";
    VByteOperationType[VByteOperationType["LSHIFT"] = 7] = "LSHIFT";
    VByteOperationType[VByteOperationType["RSHIFT"] = 8] = "RSHIFT";
    VByteOperationType[VByteOperationType["COMPLEMENT"] = 9] = "COMPLEMENT";
    VByteOperationType[VByteOperationType["ROTATELEFT"] = 10] = "ROTATELEFT";
    VByteOperationType[VByteOperationType["ROTATERIGHT"] = 11] = "ROTATERIGHT";
    VByteOperationType[VByteOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VByteOperationType || (VByteOperationType = {}));
export function vByteOperationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_OPERATION':
            return VByteOperationType.UNKNOWN_OPERATION;
        case 1:
        case 'AND':
            return VByteOperationType.AND;
        case 2:
        case 'NOT':
            return VByteOperationType.NOT;
        case 3:
        case 'OR':
            return VByteOperationType.OR;
        case 4:
        case 'XOR':
            return VByteOperationType.XOR;
        case 5:
        case 'SUB':
            return VByteOperationType.SUB;
        case 6:
        case 'SWAP':
            return VByteOperationType.SWAP;
        case 7:
        case 'LSHIFT':
            return VByteOperationType.LSHIFT;
        case 8:
        case 'RSHIFT':
            return VByteOperationType.RSHIFT;
        case 9:
        case 'COMPLEMENT':
            return VByteOperationType.COMPLEMENT;
        case 10:
        case 'ROTATELEFT':
            return VByteOperationType.ROTATELEFT;
        case 11:
        case 'ROTATERIGHT':
            return VByteOperationType.ROTATERIGHT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VByteOperationType.UNRECOGNIZED;
    }
}
export function vByteOperationTypeToJSON(object) {
    switch (object) {
        case VByteOperationType.UNKNOWN_OPERATION:
            return 'UNKNOWN_OPERATION';
        case VByteOperationType.AND:
            return 'AND';
        case VByteOperationType.NOT:
            return 'NOT';
        case VByteOperationType.OR:
            return 'OR';
        case VByteOperationType.XOR:
            return 'XOR';
        case VByteOperationType.SUB:
            return 'SUB';
        case VByteOperationType.SWAP:
            return 'SWAP';
        case VByteOperationType.LSHIFT:
            return 'LSHIFT';
        case VByteOperationType.RSHIFT:
            return 'RSHIFT';
        case VByteOperationType.COMPLEMENT:
            return 'COMPLEMENT';
        case VByteOperationType.ROTATELEFT:
            return 'ROTATELEFT';
        case VByteOperationType.ROTATERIGHT:
            return 'ROTATERIGHT';
        case VByteOperationType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VCryptoAlgorithm;
(function (VCryptoAlgorithm) {
    VCryptoAlgorithm[VCryptoAlgorithm["UNKNOWN_CRYPTO_ALGORITHM"] = 0] = "UNKNOWN_CRYPTO_ALGORITHM";
    VCryptoAlgorithm[VCryptoAlgorithm["AES"] = 1] = "AES";
    VCryptoAlgorithm[VCryptoAlgorithm["ECDH"] = 2] = "ECDH";
    VCryptoAlgorithm[VCryptoAlgorithm["RSA_PKCS15"] = 3] = "RSA_PKCS15";
    VCryptoAlgorithm[VCryptoAlgorithm["RSA_OAEP"] = 4] = "RSA_OAEP";
    VCryptoAlgorithm[VCryptoAlgorithm["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VCryptoAlgorithm || (VCryptoAlgorithm = {}));
export function vCryptoAlgorithmFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_CRYPTO_ALGORITHM':
            return VCryptoAlgorithm.UNKNOWN_CRYPTO_ALGORITHM;
        case 1:
        case 'AES':
            return VCryptoAlgorithm.AES;
        case 2:
        case 'ECDH':
            return VCryptoAlgorithm.ECDH;
        case 3:
        case 'RSA_PKCS15':
            return VCryptoAlgorithm.RSA_PKCS15;
        case 4:
        case 'RSA_OAEP':
            return VCryptoAlgorithm.RSA_OAEP;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VCryptoAlgorithm.UNRECOGNIZED;
    }
}
export function vCryptoAlgorithmToJSON(object) {
    switch (object) {
        case VCryptoAlgorithm.UNKNOWN_CRYPTO_ALGORITHM:
            return 'UNKNOWN_CRYPTO_ALGORITHM';
        case VCryptoAlgorithm.AES:
            return 'AES';
        case VCryptoAlgorithm.ECDH:
            return 'ECDH';
        case VCryptoAlgorithm.RSA_PKCS15:
            return 'RSA_PKCS15';
        case VCryptoAlgorithm.RSA_OAEP:
            return 'RSA_OAEP';
        case VCryptoAlgorithm.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VCryptoHashFunction;
(function (VCryptoHashFunction) {
    VCryptoHashFunction[VCryptoHashFunction["UNKNOWN_HASH_FUNCTION"] = 0] = "UNKNOWN_HASH_FUNCTION";
    VCryptoHashFunction[VCryptoHashFunction["HMAC_MD5"] = 1] = "HMAC_MD5";
    VCryptoHashFunction[VCryptoHashFunction["HMAC_SHA1"] = 2] = "HMAC_SHA1";
    /** HMAC_SHA256 -  */
    VCryptoHashFunction[VCryptoHashFunction["HMAC_SHA256"] = 3] = "HMAC_SHA256";
    VCryptoHashFunction[VCryptoHashFunction["HMAC_SHA384"] = 4] = "HMAC_SHA384";
    VCryptoHashFunction[VCryptoHashFunction["HMAC_SHA512"] = 5] = "HMAC_SHA512";
    VCryptoHashFunction[VCryptoHashFunction["SHA_1"] = 6] = "SHA_1";
    VCryptoHashFunction[VCryptoHashFunction["SHA_256"] = 7] = "SHA_256";
    VCryptoHashFunction[VCryptoHashFunction["SHA_384"] = 8] = "SHA_384";
    VCryptoHashFunction[VCryptoHashFunction["SHA_512"] = 9] = "SHA_512";
    VCryptoHashFunction[VCryptoHashFunction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VCryptoHashFunction || (VCryptoHashFunction = {}));
export function vCryptoHashFunctionFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_HASH_FUNCTION':
            return VCryptoHashFunction.UNKNOWN_HASH_FUNCTION;
        case 1:
        case 'HMAC_MD5':
            return VCryptoHashFunction.HMAC_MD5;
        case 2:
        case 'HMAC_SHA1':
            return VCryptoHashFunction.HMAC_SHA1;
        case 3:
        case 'HMAC_SHA256':
            return VCryptoHashFunction.HMAC_SHA256;
        case 4:
        case 'HMAC_SHA384':
            return VCryptoHashFunction.HMAC_SHA384;
        case 5:
        case 'HMAC_SHA512':
            return VCryptoHashFunction.HMAC_SHA512;
        case 6:
        case 'SHA_1':
            return VCryptoHashFunction.SHA_1;
        case 7:
        case 'SHA_256':
            return VCryptoHashFunction.SHA_256;
        case 8:
        case 'SHA_384':
            return VCryptoHashFunction.SHA_384;
        case 9:
        case 'SHA_512':
            return VCryptoHashFunction.SHA_512;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VCryptoHashFunction.UNRECOGNIZED;
    }
}
export function vCryptoHashFunctionToJSON(object) {
    switch (object) {
        case VCryptoHashFunction.UNKNOWN_HASH_FUNCTION:
            return 'UNKNOWN_HASH_FUNCTION';
        case VCryptoHashFunction.HMAC_MD5:
            return 'HMAC_MD5';
        case VCryptoHashFunction.HMAC_SHA1:
            return 'HMAC_SHA1';
        case VCryptoHashFunction.HMAC_SHA256:
            return 'HMAC_SHA256';
        case VCryptoHashFunction.HMAC_SHA384:
            return 'HMAC_SHA384';
        case VCryptoHashFunction.HMAC_SHA512:
            return 'HMAC_SHA512';
        case VCryptoHashFunction.SHA_1:
            return 'SHA_1';
        case VCryptoHashFunction.SHA_256:
            return 'SHA_256';
        case VCryptoHashFunction.SHA_384:
            return 'SHA_384';
        case VCryptoHashFunction.SHA_512:
            return 'SHA_512';
        case VCryptoHashFunction.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VDataType;
(function (VDataType) {
    VDataType[VDataType["BOOLEAN"] = 0] = "BOOLEAN";
    VDataType[VDataType["BYTES"] = 1] = "BYTES";
    VDataType[VDataType["DOUBLE"] = 2] = "DOUBLE";
    VDataType[VDataType["FLOAT"] = 3] = "FLOAT";
    VDataType[VDataType["INTEGER_32"] = 4] = "INTEGER_32";
    VDataType[VDataType["INTEGER_64"] = 5] = "INTEGER_64";
    VDataType[VDataType["STRING"] = 6] = "STRING";
    VDataType[VDataType["UINTEGER_32"] = 7] = "UINTEGER_32";
    VDataType[VDataType["UINTEGER_64"] = 8] = "UINTEGER_64";
    VDataType[VDataType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VDataType || (VDataType = {}));
export function vDataTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'BOOLEAN':
            return VDataType.BOOLEAN;
        case 1:
        case 'BYTES':
            return VDataType.BYTES;
        case 2:
        case 'DOUBLE':
            return VDataType.DOUBLE;
        case 3:
        case 'FLOAT':
            return VDataType.FLOAT;
        case 4:
        case 'INTEGER_32':
            return VDataType.INTEGER_32;
        case 5:
        case 'INTEGER_64':
            return VDataType.INTEGER_64;
        case 6:
        case 'STRING':
            return VDataType.STRING;
        case 7:
        case 'UINTEGER_32':
            return VDataType.UINTEGER_32;
        case 8:
        case 'UINTEGER_64':
            return VDataType.UINTEGER_64;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VDataType.UNRECOGNIZED;
    }
}
export function vDataTypeToJSON(object) {
    switch (object) {
        case VDataType.BOOLEAN:
            return 'BOOLEAN';
        case VDataType.BYTES:
            return 'BYTES';
        case VDataType.DOUBLE:
            return 'DOUBLE';
        case VDataType.FLOAT:
            return 'FLOAT';
        case VDataType.INTEGER_32:
            return 'INTEGER_32';
        case VDataType.INTEGER_64:
            return 'INTEGER_64';
        case VDataType.STRING:
            return 'STRING';
        case VDataType.UINTEGER_32:
            return 'UINTEGER_32';
        case VDataType.UINTEGER_64:
            return 'UINTEGER_64';
        case VDataType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VEncryptionCreationType;
(function (VEncryptionCreationType) {
    VEncryptionCreationType[VEncryptionCreationType["UNKNOWN_CREATION_TYPE"] = 0] = "UNKNOWN_CREATION_TYPE";
    VEncryptionCreationType[VEncryptionCreationType["FORWARD"] = 1] = "FORWARD";
    VEncryptionCreationType[VEncryptionCreationType["NEW"] = 2] = "NEW";
    VEncryptionCreationType[VEncryptionCreationType["REPLY"] = 3] = "REPLY";
    VEncryptionCreationType[VEncryptionCreationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VEncryptionCreationType || (VEncryptionCreationType = {}));
export function vEncryptionCreationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_CREATION_TYPE':
            return VEncryptionCreationType.UNKNOWN_CREATION_TYPE;
        case 1:
        case 'FORWARD':
            return VEncryptionCreationType.FORWARD;
        case 2:
        case 'NEW':
            return VEncryptionCreationType.NEW;
        case 3:
        case 'REPLY':
            return VEncryptionCreationType.REPLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VEncryptionCreationType.UNRECOGNIZED;
    }
}
export function vEncryptionCreationTypeToJSON(object) {
    switch (object) {
        case VEncryptionCreationType.UNKNOWN_CREATION_TYPE:
            return 'UNKNOWN_CREATION_TYPE';
        case VEncryptionCreationType.FORWARD:
            return 'FORWARD';
        case VEncryptionCreationType.NEW:
            return 'NEW';
        case VEncryptionCreationType.REPLY:
            return 'REPLY';
        case VEncryptionCreationType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VEncryptionMethods;
(function (VEncryptionMethods) {
    VEncryptionMethods[VEncryptionMethods["SIMPLE"] = 0] = "SIMPLE";
    VEncryptionMethods[VEncryptionMethods["TRANSIENT"] = 1] = "TRANSIENT";
    VEncryptionMethods[VEncryptionMethods["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VEncryptionMethods || (VEncryptionMethods = {}));
export function vEncryptionMethodsFromJSON(object) {
    switch (object) {
        case 0:
        case 'SIMPLE':
            return VEncryptionMethods.SIMPLE;
        case 1:
        case 'TRANSIENT':
            return VEncryptionMethods.TRANSIENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VEncryptionMethods.UNRECOGNIZED;
    }
}
export function vEncryptionMethodsToJSON(object) {
    switch (object) {
        case VEncryptionMethods.SIMPLE:
            return 'SIMPLE';
        case VEncryptionMethods.TRANSIENT:
            return 'TRANSIENT';
        case VEncryptionMethods.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VImageFormat;
(function (VImageFormat) {
    VImageFormat[VImageFormat["UNKNOWN_IMAGE_FORMAT"] = 0] = "UNKNOWN_IMAGE_FORMAT";
    VImageFormat[VImageFormat["BMP"] = 1] = "BMP";
    VImageFormat[VImageFormat["GIF"] = 2] = "GIF";
    VImageFormat[VImageFormat["JPEG"] = 3] = "JPEG";
    VImageFormat[VImageFormat["PNG"] = 4] = "PNG";
    VImageFormat[VImageFormat["TIFF"] = 5] = "TIFF";
    VImageFormat[VImageFormat["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VImageFormat || (VImageFormat = {}));
export function vImageFormatFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_IMAGE_FORMAT':
            return VImageFormat.UNKNOWN_IMAGE_FORMAT;
        case 1:
        case 'BMP':
            return VImageFormat.BMP;
        case 2:
        case 'GIF':
            return VImageFormat.GIF;
        case 3:
        case 'JPEG':
            return VImageFormat.JPEG;
        case 4:
        case 'PNG':
            return VImageFormat.PNG;
        case 5:
        case 'TIFF':
            return VImageFormat.TIFF;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VImageFormat.UNRECOGNIZED;
    }
}
export function vImageFormatToJSON(object) {
    switch (object) {
        case VImageFormat.UNKNOWN_IMAGE_FORMAT:
            return 'UNKNOWN_IMAGE_FORMAT';
        case VImageFormat.BMP:
            return 'BMP';
        case VImageFormat.GIF:
            return 'GIF';
        case VImageFormat.JPEG:
            return 'JPEG';
        case VImageFormat.PNG:
            return 'PNG';
        case VImageFormat.TIFF:
            return 'TIFF';
        case VImageFormat.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VLoginMethod;
(function (VLoginMethod) {
    VLoginMethod[VLoginMethod["USER_PASSWORD"] = 0] = "USER_PASSWORD";
    VLoginMethod[VLoginMethod["FACEBOOK"] = 1] = "FACEBOOK";
    VLoginMethod[VLoginMethod["GOOGLE"] = 2] = "GOOGLE";
    VLoginMethod[VLoginMethod["TWITTER"] = 3] = "TWITTER";
    VLoginMethod[VLoginMethod["MICROSOFT_ONLINE"] = 4] = "MICROSOFT_ONLINE";
    VLoginMethod[VLoginMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VLoginMethod || (VLoginMethod = {}));
export function vLoginMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'USER_PASSWORD':
            return VLoginMethod.USER_PASSWORD;
        case 1:
        case 'FACEBOOK':
            return VLoginMethod.FACEBOOK;
        case 2:
        case 'GOOGLE':
            return VLoginMethod.GOOGLE;
        case 3:
        case 'TWITTER':
            return VLoginMethod.TWITTER;
        case 4:
        case 'MICROSOFT_ONLINE':
            return VLoginMethod.MICROSOFT_ONLINE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VLoginMethod.UNRECOGNIZED;
    }
}
export function vLoginMethodToJSON(object) {
    switch (object) {
        case VLoginMethod.USER_PASSWORD:
            return 'USER_PASSWORD';
        case VLoginMethod.FACEBOOK:
            return 'FACEBOOK';
        case VLoginMethod.GOOGLE:
            return 'GOOGLE';
        case VLoginMethod.TWITTER:
            return 'TWITTER';
        case VLoginMethod.MICROSOFT_ONLINE:
            return 'MICROSOFT_ONLINE';
        case VLoginMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var QRStatus;
(function (QRStatus) {
    QRStatus[QRStatus["UNKNOWN_QR_STATUS"] = 0] = "UNKNOWN_QR_STATUS";
    QRStatus[QRStatus["QR_PENDING"] = 1] = "QR_PENDING";
    QRStatus[QRStatus["QR_VERIFIED"] = 2] = "QR_VERIFIED";
    QRStatus[QRStatus["QR_EXPIRED"] = 3] = "QR_EXPIRED";
    QRStatus[QRStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(QRStatus || (QRStatus = {}));
export function qRStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_QR_STATUS':
            return QRStatus.UNKNOWN_QR_STATUS;
        case 1:
        case 'QR_PENDING':
            return QRStatus.QR_PENDING;
        case 2:
        case 'QR_VERIFIED':
            return QRStatus.QR_VERIFIED;
        case 3:
        case 'QR_EXPIRED':
            return QRStatus.QR_EXPIRED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return QRStatus.UNRECOGNIZED;
    }
}
export function qRStatusToJSON(object) {
    switch (object) {
        case QRStatus.UNKNOWN_QR_STATUS:
            return 'UNKNOWN_QR_STATUS';
        case QRStatus.QR_PENDING:
            return 'QR_PENDING';
        case QRStatus.QR_VERIFIED:
            return 'QR_VERIFIED';
        case QRStatus.QR_EXPIRED:
            return 'QR_EXPIRED';
        case QRStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VResponseCode;
(function (VResponseCode) {
    VResponseCode[VResponseCode["UNKNOWN_RESPONSE_CODE"] = 0] = "UNKNOWN_RESPONSE_CODE";
    VResponseCode[VResponseCode["SUCCESS"] = 1] = "SUCCESS";
    VResponseCode[VResponseCode["NO_INTERNET"] = 2] = "NO_INTERNET";
    VResponseCode[VResponseCode["STATE_INVALID"] = 3] = "STATE_INVALID";
    VResponseCode[VResponseCode["STATE_INVALID_GPS"] = 4] = "STATE_INVALID_GPS";
    VResponseCode[VResponseCode["STATE_QR_REQUIRED"] = 5] = "STATE_QR_REQUIRED";
    VResponseCode[VResponseCode["STATE_UNAUTHORIZED_USER"] = 6] = "STATE_UNAUTHORIZED_USER";
    VResponseCode[VResponseCode["ACCTSTATE_USER_NOT_FOUND"] = 7] = "ACCTSTATE_USER_NOT_FOUND";
    VResponseCode[VResponseCode["ACCTSTATE_User_SUSPENDED"] = 8] = "ACCTSTATE_User_SUSPENDED";
    VResponseCode[VResponseCode["ACCTSTATE_USER_TYPE_INCORRECT"] = 9] = "ACCTSTATE_USER_TYPE_INCORRECT";
    VResponseCode[VResponseCode["ACCTSTATE_BLOCKED_DEVICE"] = 10] = "ACCTSTATE_BLOCKED_DEVICE";
    VResponseCode[VResponseCode["ACCTSTATE_BLOCKED_DOMAIN"] = 11] = "ACCTSTATE_BLOCKED_DOMAIN";
    VResponseCode[VResponseCode["ACCTSTATE_BLOCKED_EMAIL"] = 12] = "ACCTSTATE_BLOCKED_EMAIL";
    VResponseCode[VResponseCode["ACCTSTATE_CLEAR_INSTALLATION"] = 13] = "ACCTSTATE_CLEAR_INSTALLATION";
    VResponseCode[VResponseCode["ACCTSTATE_DEVICE_NOT_FOUND"] = 14] = "ACCTSTATE_DEVICE_NOT_FOUND";
    VResponseCode[VResponseCode["ACCTSTATE_PASSWORD_CHANGE_REQUIRED"] = 15] = "ACCTSTATE_PASSWORD_CHANGE_REQUIRED";
    VResponseCode[VResponseCode["ACCTSTATE_PASSWORD_EXPIRED"] = 16] = "ACCTSTATE_PASSWORD_EXPIRED";
    VResponseCode[VResponseCode["ACCTSTATE_SOFTWARE_UPDATE_REQUIRED"] = 17] = "ACCTSTATE_SOFTWARE_UPDATE_REQUIRED";
    VResponseCode[VResponseCode["EXCEPTION"] = 18] = "EXCEPTION";
    VResponseCode[VResponseCode["UNKNOWN_URL"] = 19] = "UNKNOWN_URL";
    VResponseCode[VResponseCode["BAD_REQUEST"] = 20] = "BAD_REQUEST";
    VResponseCode[VResponseCode["RSA_SIGNING_FAILED"] = 21] = "RSA_SIGNING_FAILED";
    VResponseCode[VResponseCode["RSA_CONFIRM_SIGNING_FAILED"] = 22] = "RSA_CONFIRM_SIGNING_FAILED";
    VResponseCode[VResponseCode["ECC_SIGNING_FAILED"] = 23] = "ECC_SIGNING_FAILED";
    VResponseCode[VResponseCode["ECC_CONFIRM_SIGNING_FAILED"] = 24] = "ECC_CONFIRM_SIGNING_FAILED";
    VResponseCode[VResponseCode["LOGIN_DENIED_GPS"] = 25] = "LOGIN_DENIED_GPS";
    VResponseCode[VResponseCode["LOGIN_DENIED_USER_PWD"] = 26] = "LOGIN_DENIED_USER_PWD";
    VResponseCode[VResponseCode["ENCRYPTION_FAILED"] = 27] = "ENCRYPTION_FAILED";
    VResponseCode[VResponseCode["UNKNOWN_SIGNING_METHOD"] = 28] = "UNKNOWN_SIGNING_METHOD";
    VResponseCode[VResponseCode["INVALID_SESSION_ID"] = 29] = "INVALID_SESSION_ID";
    VResponseCode[VResponseCode["HTTPCLIENT_RESPONSE_FAILED"] = 30] = "HTTPCLIENT_RESPONSE_FAILED";
    VResponseCode[VResponseCode["ECC_DECRYPTION_BADKEYS"] = 31] = "ECC_DECRYPTION_BADKEYS";
    VResponseCode[VResponseCode["AES_CRYPTOPROVIDER_NULL"] = 32] = "AES_CRYPTOPROVIDER_NULL";
    VResponseCode[VResponseCode["PUBLIC_KEY_RESPONSE_FAILED"] = 33] = "PUBLIC_KEY_RESPONSE_FAILED";
    VResponseCode[VResponseCode["PUBLIC_KEY_REQUEST_FAILED"] = 34] = "PUBLIC_KEY_REQUEST_FAILED";
    VResponseCode[VResponseCode["BAD_RESPONSE"] = 35] = "BAD_RESPONSE";
    VResponseCode[VResponseCode["BLOCKED_DOMAIN"] = 36] = "BLOCKED_DOMAIN";
    VResponseCode[VResponseCode["DISCOVERY_ERROR"] = 37] = "DISCOVERY_ERROR";
    VResponseCode[VResponseCode["REGISTER_ERROR"] = 38] = "REGISTER_ERROR";
    VResponseCode[VResponseCode["LOGIN_ERROR"] = 39] = "LOGIN_ERROR";
    VResponseCode[VResponseCode["SAVEFILE_FAILED"] = 40] = "SAVEFILE_FAILED";
    VResponseCode[VResponseCode["DECRYPT_FAILED"] = 41] = "DECRYPT_FAILED";
    VResponseCode[VResponseCode["DECRYPTS2_FAILED"] = 42] = "DECRYPTS2_FAILED";
    VResponseCode[VResponseCode["LOADSECUREFILE_FAILED"] = 43] = "LOADSECUREFILE_FAILED";
    VResponseCode[VResponseCode["TOKEN_EXPIRED"] = 44] = "TOKEN_EXPIRED";
    VResponseCode[VResponseCode["SUNRISE_FAILED"] = 45] = "SUNRISE_FAILED";
    VResponseCode[VResponseCode["SUNSET_FAILED"] = 46] = "SUNSET_FAILED";
    VResponseCode[VResponseCode["DECRYPT_FAILED_REVOKED"] = 47] = "DECRYPT_FAILED_REVOKED";
    VResponseCode[VResponseCode["DECRYPT_FAILED_SHREDDED"] = 48] = "DECRYPT_FAILED_SHREDDED";
    VResponseCode[VResponseCode["ISALIVE_FAILED"] = 49] = "ISALIVE_FAILED";
    VResponseCode[VResponseCode["DEVICE_DOES_NOT_SUPPORT_DRM"] = 50] = "DEVICE_DOES_NOT_SUPPORT_DRM";
    VResponseCode[VResponseCode["STATE_AUTHENTICATOR_REQUIRED"] = 51] = "STATE_AUTHENTICATOR_REQUIRED";
    VResponseCode[VResponseCode["STATE_BIOMETRICS_REQUIRED"] = 52] = "STATE_BIOMETRICS_REQUIRED";
    VResponseCode[VResponseCode["STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED"] = 53] = "STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED";
    VResponseCode[VResponseCode["STATE_BIOMETRICS_KEY_DOES_NOT_MATCH"] = 54] = "STATE_BIOMETRICS_KEY_DOES_NOT_MATCH";
    VResponseCode[VResponseCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VResponseCode || (VResponseCode = {}));
export function vResponseCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_RESPONSE_CODE':
            return VResponseCode.UNKNOWN_RESPONSE_CODE;
        case 1:
        case 'SUCCESS':
            return VResponseCode.SUCCESS;
        case 2:
        case 'NO_INTERNET':
            return VResponseCode.NO_INTERNET;
        case 3:
        case 'STATE_INVALID':
            return VResponseCode.STATE_INVALID;
        case 4:
        case 'STATE_INVALID_GPS':
            return VResponseCode.STATE_INVALID_GPS;
        case 5:
        case 'STATE_QR_REQUIRED':
            return VResponseCode.STATE_QR_REQUIRED;
        case 6:
        case 'STATE_UNAUTHORIZED_USER':
            return VResponseCode.STATE_UNAUTHORIZED_USER;
        case 7:
        case 'ACCTSTATE_USER_NOT_FOUND':
            return VResponseCode.ACCTSTATE_USER_NOT_FOUND;
        case 8:
        case 'ACCTSTATE_User_SUSPENDED':
            return VResponseCode.ACCTSTATE_User_SUSPENDED;
        case 9:
        case 'ACCTSTATE_USER_TYPE_INCORRECT':
            return VResponseCode.ACCTSTATE_USER_TYPE_INCORRECT;
        case 10:
        case 'ACCTSTATE_BLOCKED_DEVICE':
            return VResponseCode.ACCTSTATE_BLOCKED_DEVICE;
        case 11:
        case 'ACCTSTATE_BLOCKED_DOMAIN':
            return VResponseCode.ACCTSTATE_BLOCKED_DOMAIN;
        case 12:
        case 'ACCTSTATE_BLOCKED_EMAIL':
            return VResponseCode.ACCTSTATE_BLOCKED_EMAIL;
        case 13:
        case 'ACCTSTATE_CLEAR_INSTALLATION':
            return VResponseCode.ACCTSTATE_CLEAR_INSTALLATION;
        case 14:
        case 'ACCTSTATE_DEVICE_NOT_FOUND':
            return VResponseCode.ACCTSTATE_DEVICE_NOT_FOUND;
        case 15:
        case 'ACCTSTATE_PASSWORD_CHANGE_REQUIRED':
            return VResponseCode.ACCTSTATE_PASSWORD_CHANGE_REQUIRED;
        case 16:
        case 'ACCTSTATE_PASSWORD_EXPIRED':
            return VResponseCode.ACCTSTATE_PASSWORD_EXPIRED;
        case 17:
        case 'ACCTSTATE_SOFTWARE_UPDATE_REQUIRED':
            return VResponseCode.ACCTSTATE_SOFTWARE_UPDATE_REQUIRED;
        case 18:
        case 'EXCEPTION':
            return VResponseCode.EXCEPTION;
        case 19:
        case 'UNKNOWN_URL':
            return VResponseCode.UNKNOWN_URL;
        case 20:
        case 'BAD_REQUEST':
            return VResponseCode.BAD_REQUEST;
        case 21:
        case 'RSA_SIGNING_FAILED':
            return VResponseCode.RSA_SIGNING_FAILED;
        case 22:
        case 'RSA_CONFIRM_SIGNING_FAILED':
            return VResponseCode.RSA_CONFIRM_SIGNING_FAILED;
        case 23:
        case 'ECC_SIGNING_FAILED':
            return VResponseCode.ECC_SIGNING_FAILED;
        case 24:
        case 'ECC_CONFIRM_SIGNING_FAILED':
            return VResponseCode.ECC_CONFIRM_SIGNING_FAILED;
        case 25:
        case 'LOGIN_DENIED_GPS':
            return VResponseCode.LOGIN_DENIED_GPS;
        case 26:
        case 'LOGIN_DENIED_USER_PWD':
            return VResponseCode.LOGIN_DENIED_USER_PWD;
        case 27:
        case 'ENCRYPTION_FAILED':
            return VResponseCode.ENCRYPTION_FAILED;
        case 28:
        case 'UNKNOWN_SIGNING_METHOD':
            return VResponseCode.UNKNOWN_SIGNING_METHOD;
        case 29:
        case 'INVALID_SESSION_ID':
            return VResponseCode.INVALID_SESSION_ID;
        case 30:
        case 'HTTPCLIENT_RESPONSE_FAILED':
            return VResponseCode.HTTPCLIENT_RESPONSE_FAILED;
        case 31:
        case 'ECC_DECRYPTION_BADKEYS':
            return VResponseCode.ECC_DECRYPTION_BADKEYS;
        case 32:
        case 'AES_CRYPTOPROVIDER_NULL':
            return VResponseCode.AES_CRYPTOPROVIDER_NULL;
        case 33:
        case 'PUBLIC_KEY_RESPONSE_FAILED':
            return VResponseCode.PUBLIC_KEY_RESPONSE_FAILED;
        case 34:
        case 'PUBLIC_KEY_REQUEST_FAILED':
            return VResponseCode.PUBLIC_KEY_REQUEST_FAILED;
        case 35:
        case 'BAD_RESPONSE':
            return VResponseCode.BAD_RESPONSE;
        case 36:
        case 'BLOCKED_DOMAIN':
            return VResponseCode.BLOCKED_DOMAIN;
        case 37:
        case 'DISCOVERY_ERROR':
            return VResponseCode.DISCOVERY_ERROR;
        case 38:
        case 'REGISTER_ERROR':
            return VResponseCode.REGISTER_ERROR;
        case 39:
        case 'LOGIN_ERROR':
            return VResponseCode.LOGIN_ERROR;
        case 40:
        case 'SAVEFILE_FAILED':
            return VResponseCode.SAVEFILE_FAILED;
        case 41:
        case 'DECRYPT_FAILED':
            return VResponseCode.DECRYPT_FAILED;
        case 42:
        case 'DECRYPTS2_FAILED':
            return VResponseCode.DECRYPTS2_FAILED;
        case 43:
        case 'LOADSECUREFILE_FAILED':
            return VResponseCode.LOADSECUREFILE_FAILED;
        case 44:
        case 'TOKEN_EXPIRED':
            return VResponseCode.TOKEN_EXPIRED;
        case 45:
        case 'SUNRISE_FAILED':
            return VResponseCode.SUNRISE_FAILED;
        case 46:
        case 'SUNSET_FAILED':
            return VResponseCode.SUNSET_FAILED;
        case 47:
        case 'DECRYPT_FAILED_REVOKED':
            return VResponseCode.DECRYPT_FAILED_REVOKED;
        case 48:
        case 'DECRYPT_FAILED_SHREDDED':
            return VResponseCode.DECRYPT_FAILED_SHREDDED;
        case 49:
        case 'ISALIVE_FAILED':
            return VResponseCode.ISALIVE_FAILED;
        case 50:
        case 'DEVICE_DOES_NOT_SUPPORT_DRM':
            return VResponseCode.DEVICE_DOES_NOT_SUPPORT_DRM;
        case 51:
        case 'STATE_AUTHENTICATOR_REQUIRED':
            return VResponseCode.STATE_AUTHENTICATOR_REQUIRED;
        case 52:
        case 'STATE_BIOMETRICS_REQUIRED':
            return VResponseCode.STATE_BIOMETRICS_REQUIRED;
        case 53:
        case 'STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED':
            return VResponseCode.STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED;
        case 54:
        case 'STATE_BIOMETRICS_KEY_DOES_NOT_MATCH':
            return VResponseCode.STATE_BIOMETRICS_KEY_DOES_NOT_MATCH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VResponseCode.UNRECOGNIZED;
    }
}
export function vResponseCodeToJSON(object) {
    switch (object) {
        case VResponseCode.UNKNOWN_RESPONSE_CODE:
            return 'UNKNOWN_RESPONSE_CODE';
        case VResponseCode.SUCCESS:
            return 'SUCCESS';
        case VResponseCode.NO_INTERNET:
            return 'NO_INTERNET';
        case VResponseCode.STATE_INVALID:
            return 'STATE_INVALID';
        case VResponseCode.STATE_INVALID_GPS:
            return 'STATE_INVALID_GPS';
        case VResponseCode.STATE_QR_REQUIRED:
            return 'STATE_QR_REQUIRED';
        case VResponseCode.STATE_UNAUTHORIZED_USER:
            return 'STATE_UNAUTHORIZED_USER';
        case VResponseCode.ACCTSTATE_USER_NOT_FOUND:
            return 'ACCTSTATE_USER_NOT_FOUND';
        case VResponseCode.ACCTSTATE_User_SUSPENDED:
            return 'ACCTSTATE_User_SUSPENDED';
        case VResponseCode.ACCTSTATE_USER_TYPE_INCORRECT:
            return 'ACCTSTATE_USER_TYPE_INCORRECT';
        case VResponseCode.ACCTSTATE_BLOCKED_DEVICE:
            return 'ACCTSTATE_BLOCKED_DEVICE';
        case VResponseCode.ACCTSTATE_BLOCKED_DOMAIN:
            return 'ACCTSTATE_BLOCKED_DOMAIN';
        case VResponseCode.ACCTSTATE_BLOCKED_EMAIL:
            return 'ACCTSTATE_BLOCKED_EMAIL';
        case VResponseCode.ACCTSTATE_CLEAR_INSTALLATION:
            return 'ACCTSTATE_CLEAR_INSTALLATION';
        case VResponseCode.ACCTSTATE_DEVICE_NOT_FOUND:
            return 'ACCTSTATE_DEVICE_NOT_FOUND';
        case VResponseCode.ACCTSTATE_PASSWORD_CHANGE_REQUIRED:
            return 'ACCTSTATE_PASSWORD_CHANGE_REQUIRED';
        case VResponseCode.ACCTSTATE_PASSWORD_EXPIRED:
            return 'ACCTSTATE_PASSWORD_EXPIRED';
        case VResponseCode.ACCTSTATE_SOFTWARE_UPDATE_REQUIRED:
            return 'ACCTSTATE_SOFTWARE_UPDATE_REQUIRED';
        case VResponseCode.EXCEPTION:
            return 'EXCEPTION';
        case VResponseCode.UNKNOWN_URL:
            return 'UNKNOWN_URL';
        case VResponseCode.BAD_REQUEST:
            return 'BAD_REQUEST';
        case VResponseCode.RSA_SIGNING_FAILED:
            return 'RSA_SIGNING_FAILED';
        case VResponseCode.RSA_CONFIRM_SIGNING_FAILED:
            return 'RSA_CONFIRM_SIGNING_FAILED';
        case VResponseCode.ECC_SIGNING_FAILED:
            return 'ECC_SIGNING_FAILED';
        case VResponseCode.ECC_CONFIRM_SIGNING_FAILED:
            return 'ECC_CONFIRM_SIGNING_FAILED';
        case VResponseCode.LOGIN_DENIED_GPS:
            return 'LOGIN_DENIED_GPS';
        case VResponseCode.LOGIN_DENIED_USER_PWD:
            return 'LOGIN_DENIED_USER_PWD';
        case VResponseCode.ENCRYPTION_FAILED:
            return 'ENCRYPTION_FAILED';
        case VResponseCode.UNKNOWN_SIGNING_METHOD:
            return 'UNKNOWN_SIGNING_METHOD';
        case VResponseCode.INVALID_SESSION_ID:
            return 'INVALID_SESSION_ID';
        case VResponseCode.HTTPCLIENT_RESPONSE_FAILED:
            return 'HTTPCLIENT_RESPONSE_FAILED';
        case VResponseCode.ECC_DECRYPTION_BADKEYS:
            return 'ECC_DECRYPTION_BADKEYS';
        case VResponseCode.AES_CRYPTOPROVIDER_NULL:
            return 'AES_CRYPTOPROVIDER_NULL';
        case VResponseCode.PUBLIC_KEY_RESPONSE_FAILED:
            return 'PUBLIC_KEY_RESPONSE_FAILED';
        case VResponseCode.PUBLIC_KEY_REQUEST_FAILED:
            return 'PUBLIC_KEY_REQUEST_FAILED';
        case VResponseCode.BAD_RESPONSE:
            return 'BAD_RESPONSE';
        case VResponseCode.BLOCKED_DOMAIN:
            return 'BLOCKED_DOMAIN';
        case VResponseCode.DISCOVERY_ERROR:
            return 'DISCOVERY_ERROR';
        case VResponseCode.REGISTER_ERROR:
            return 'REGISTER_ERROR';
        case VResponseCode.LOGIN_ERROR:
            return 'LOGIN_ERROR';
        case VResponseCode.SAVEFILE_FAILED:
            return 'SAVEFILE_FAILED';
        case VResponseCode.DECRYPT_FAILED:
            return 'DECRYPT_FAILED';
        case VResponseCode.DECRYPTS2_FAILED:
            return 'DECRYPTS2_FAILED';
        case VResponseCode.LOADSECUREFILE_FAILED:
            return 'LOADSECUREFILE_FAILED';
        case VResponseCode.TOKEN_EXPIRED:
            return 'TOKEN_EXPIRED';
        case VResponseCode.SUNRISE_FAILED:
            return 'SUNRISE_FAILED';
        case VResponseCode.SUNSET_FAILED:
            return 'SUNSET_FAILED';
        case VResponseCode.DECRYPT_FAILED_REVOKED:
            return 'DECRYPT_FAILED_REVOKED';
        case VResponseCode.DECRYPT_FAILED_SHREDDED:
            return 'DECRYPT_FAILED_SHREDDED';
        case VResponseCode.ISALIVE_FAILED:
            return 'ISALIVE_FAILED';
        case VResponseCode.DEVICE_DOES_NOT_SUPPORT_DRM:
            return 'DEVICE_DOES_NOT_SUPPORT_DRM';
        case VResponseCode.STATE_AUTHENTICATOR_REQUIRED:
            return 'STATE_AUTHENTICATOR_REQUIRED';
        case VResponseCode.STATE_BIOMETRICS_REQUIRED:
            return 'STATE_BIOMETRICS_REQUIRED';
        case VResponseCode.STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED:
            return 'STATE_DEVICE_BIOMETRICS_NOT_CONFIGURED';
        case VResponseCode.STATE_BIOMETRICS_KEY_DOES_NOT_MATCH:
            return 'STATE_BIOMETRICS_KEY_DOES_NOT_MATCH';
        case VResponseCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VSecureFilePartitionType;
(function (VSecureFilePartitionType) {
    VSecureFilePartitionType[VSecureFilePartitionType["PLAINTEXT"] = 0] = "PLAINTEXT";
    VSecureFilePartitionType[VSecureFilePartitionType["HTML"] = 1] = "HTML";
    VSecureFilePartitionType[VSecureFilePartitionType["DOCUMENT"] = 2] = "DOCUMENT";
    VSecureFilePartitionType[VSecureFilePartitionType["NOTES"] = 3] = "NOTES";
    VSecureFilePartitionType[VSecureFilePartitionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VSecureFilePartitionType || (VSecureFilePartitionType = {}));
export function vSecureFilePartitionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'PLAINTEXT':
            return VSecureFilePartitionType.PLAINTEXT;
        case 1:
        case 'HTML':
            return VSecureFilePartitionType.HTML;
        case 2:
        case 'DOCUMENT':
            return VSecureFilePartitionType.DOCUMENT;
        case 3:
        case 'NOTES':
            return VSecureFilePartitionType.NOTES;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VSecureFilePartitionType.UNRECOGNIZED;
    }
}
export function vSecureFilePartitionTypeToJSON(object) {
    switch (object) {
        case VSecureFilePartitionType.PLAINTEXT:
            return 'PLAINTEXT';
        case VSecureFilePartitionType.HTML:
            return 'HTML';
        case VSecureFilePartitionType.DOCUMENT:
            return 'DOCUMENT';
        case VSecureFilePartitionType.NOTES:
            return 'NOTES';
        case VSecureFilePartitionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VUserType;
(function (VUserType) {
    VUserType[VUserType["FREE"] = 0] = "FREE";
    VUserType[VUserType["LICENSED"] = 1] = "LICENSED";
    VUserType[VUserType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VUserType || (VUserType = {}));
export function vUserTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'FREE':
            return VUserType.FREE;
        case 1:
        case 'LICENSED':
            return VUserType.LICENSED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VUserType.UNRECOGNIZED;
    }
}
export function vUserTypeToJSON(object) {
    switch (object) {
        case VUserType.FREE:
            return 'FREE';
        case VUserType.LICENSED:
            return 'LICENSED';
        case VUserType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VCryptoKey_VCryptoKeyStatus;
(function (VCryptoKey_VCryptoKeyStatus) {
    VCryptoKey_VCryptoKeyStatus[VCryptoKey_VCryptoKeyStatus["UNKNOWN_KEY_STATUS"] = 0] = "UNKNOWN_KEY_STATUS";
    VCryptoKey_VCryptoKeyStatus[VCryptoKey_VCryptoKeyStatus["ACTIVE"] = 1] = "ACTIVE";
    VCryptoKey_VCryptoKeyStatus[VCryptoKey_VCryptoKeyStatus["INACTIVE"] = 2] = "INACTIVE";
    VCryptoKey_VCryptoKeyStatus[VCryptoKey_VCryptoKeyStatus["UNSECURE"] = 3] = "UNSECURE";
    VCryptoKey_VCryptoKeyStatus[VCryptoKey_VCryptoKeyStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VCryptoKey_VCryptoKeyStatus || (VCryptoKey_VCryptoKeyStatus = {}));
export function vCryptoKey_VCryptoKeyStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_KEY_STATUS':
            return VCryptoKey_VCryptoKeyStatus.UNKNOWN_KEY_STATUS;
        case 1:
        case 'ACTIVE':
            return VCryptoKey_VCryptoKeyStatus.ACTIVE;
        case 2:
        case 'INACTIVE':
            return VCryptoKey_VCryptoKeyStatus.INACTIVE;
        case 3:
        case 'UNSECURE':
            return VCryptoKey_VCryptoKeyStatus.UNSECURE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VCryptoKey_VCryptoKeyStatus.UNRECOGNIZED;
    }
}
export function vCryptoKey_VCryptoKeyStatusToJSON(object) {
    switch (object) {
        case VCryptoKey_VCryptoKeyStatus.UNKNOWN_KEY_STATUS:
            return 'UNKNOWN_KEY_STATUS';
        case VCryptoKey_VCryptoKeyStatus.ACTIVE:
            return 'ACTIVE';
        case VCryptoKey_VCryptoKeyStatus.INACTIVE:
            return 'INACTIVE';
        case VCryptoKey_VCryptoKeyStatus.UNSECURE:
            return 'UNSECURE';
        case VCryptoKey_VCryptoKeyStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VCryptoKey_VCryptoKeyType;
(function (VCryptoKey_VCryptoKeyType) {
    VCryptoKey_VCryptoKeyType[VCryptoKey_VCryptoKeyType["UNKNOWN_KEY_TYPE"] = 0] = "UNKNOWN_KEY_TYPE";
    VCryptoKey_VCryptoKeyType[VCryptoKey_VCryptoKeyType["SIGNING"] = 1] = "SIGNING";
    /** EXCHANGE - ECC used to create aes sessionKey or RSA aes sessionKey is in ClientResponse */
    VCryptoKey_VCryptoKeyType[VCryptoKey_VCryptoKeyType["EXCHANGE"] = 2] = "EXCHANGE";
    VCryptoKey_VCryptoKeyType[VCryptoKey_VCryptoKeyType["VERIFICATION"] = 3] = "VERIFICATION";
    VCryptoKey_VCryptoKeyType[VCryptoKey_VCryptoKeyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VCryptoKey_VCryptoKeyType || (VCryptoKey_VCryptoKeyType = {}));
export function vCryptoKey_VCryptoKeyTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_KEY_TYPE':
            return VCryptoKey_VCryptoKeyType.UNKNOWN_KEY_TYPE;
        case 1:
        case 'SIGNING':
            return VCryptoKey_VCryptoKeyType.SIGNING;
        case 2:
        case 'EXCHANGE':
            return VCryptoKey_VCryptoKeyType.EXCHANGE;
        case 3:
        case 'VERIFICATION':
            return VCryptoKey_VCryptoKeyType.VERIFICATION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VCryptoKey_VCryptoKeyType.UNRECOGNIZED;
    }
}
export function vCryptoKey_VCryptoKeyTypeToJSON(object) {
    switch (object) {
        case VCryptoKey_VCryptoKeyType.UNKNOWN_KEY_TYPE:
            return 'UNKNOWN_KEY_TYPE';
        case VCryptoKey_VCryptoKeyType.SIGNING:
            return 'SIGNING';
        case VCryptoKey_VCryptoKeyType.EXCHANGE:
            return 'EXCHANGE';
        case VCryptoKey_VCryptoKeyType.VERIFICATION:
            return 'VERIFICATION';
        case VCryptoKey_VCryptoKeyType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var VEmailVerifyResponse_VEmailVerifyResponseCode;
(function (VEmailVerifyResponse_VEmailVerifyResponseCode) {
    VEmailVerifyResponse_VEmailVerifyResponseCode[VEmailVerifyResponse_VEmailVerifyResponseCode["UNKNOWN_EMAIL_VERIFY"] = 0] = "UNKNOWN_EMAIL_VERIFY";
    VEmailVerifyResponse_VEmailVerifyResponseCode[VEmailVerifyResponse_VEmailVerifyResponseCode["PENDING"] = 1] = "PENDING";
    VEmailVerifyResponse_VEmailVerifyResponseCode[VEmailVerifyResponse_VEmailVerifyResponseCode["VERIFIED"] = 2] = "VERIFIED";
    VEmailVerifyResponse_VEmailVerifyResponseCode[VEmailVerifyResponse_VEmailVerifyResponseCode["EXPIRED"] = 3] = "EXPIRED";
    VEmailVerifyResponse_VEmailVerifyResponseCode[VEmailVerifyResponse_VEmailVerifyResponseCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VEmailVerifyResponse_VEmailVerifyResponseCode || (VEmailVerifyResponse_VEmailVerifyResponseCode = {}));
export function vEmailVerifyResponse_VEmailVerifyResponseCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN_EMAIL_VERIFY':
            return VEmailVerifyResponse_VEmailVerifyResponseCode.UNKNOWN_EMAIL_VERIFY;
        case 1:
        case 'PENDING':
            return VEmailVerifyResponse_VEmailVerifyResponseCode.PENDING;
        case 2:
        case 'VERIFIED':
            return VEmailVerifyResponse_VEmailVerifyResponseCode.VERIFIED;
        case 3:
        case 'EXPIRED':
            return VEmailVerifyResponse_VEmailVerifyResponseCode.EXPIRED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VEmailVerifyResponse_VEmailVerifyResponseCode.UNRECOGNIZED;
    }
}
export function vEmailVerifyResponse_VEmailVerifyResponseCodeToJSON(object) {
    switch (object) {
        case VEmailVerifyResponse_VEmailVerifyResponseCode.UNKNOWN_EMAIL_VERIFY:
            return 'UNKNOWN_EMAIL_VERIFY';
        case VEmailVerifyResponse_VEmailVerifyResponseCode.PENDING:
            return 'PENDING';
        case VEmailVerifyResponse_VEmailVerifyResponseCode.VERIFIED:
            return 'VERIFIED';
        case VEmailVerifyResponse_VEmailVerifyResponseCode.EXPIRED:
            return 'EXPIRED';
        case VEmailVerifyResponse_VEmailVerifyResponseCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
function createBaseVByteOperation() {
    return {
        operationType: 0,
        subBytes: new Uint8Array(),
        swapLeftCount: 0,
        shiftCount: 0,
        rotateCount: 0
    };
}
export const VByteOperation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.operationType !== 0) {
            writer.uint32(8).int32(message.operationType);
        }
        if (message.subBytes.length !== 0) {
            writer.uint32(18).bytes(message.subBytes);
        }
        if (message.swapLeftCount !== 0) {
            writer.uint32(24).int32(message.swapLeftCount);
        }
        if (message.shiftCount !== 0) {
            writer.uint32(32).int32(message.shiftCount);
        }
        if (message.rotateCount !== 0) {
            writer.uint32(40).int32(message.rotateCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVByteOperation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operationType = reader.int32();
                    break;
                case 2:
                    message.subBytes = reader.bytes();
                    break;
                case 3:
                    message.swapLeftCount = reader.int32();
                    break;
                case 4:
                    message.shiftCount = reader.int32();
                    break;
                case 5:
                    message.rotateCount = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operationType: isSet(object.operationType)
                ? vByteOperationTypeFromJSON(object.operationType)
                : 0,
            subBytes: isSet(object.subBytes)
                ? bytesFromBase64(object.subBytes)
                : new Uint8Array(),
            swapLeftCount: isSet(object.swapLeftCount)
                ? Number(object.swapLeftCount)
                : 0,
            shiftCount: isSet(object.shiftCount) ? Number(object.shiftCount) : 0,
            rotateCount: isSet(object.rotateCount) ? Number(object.rotateCount) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.operationType !== undefined &&
            (obj.operationType = vByteOperationTypeToJSON(message.operationType));
        message.subBytes !== undefined &&
            (obj.subBytes = base64FromBytes(message.subBytes !== undefined ? message.subBytes : new Uint8Array()));
        message.swapLeftCount !== undefined &&
            (obj.swapLeftCount = Math.round(message.swapLeftCount));
        message.shiftCount !== undefined &&
            (obj.shiftCount = Math.round(message.shiftCount));
        message.rotateCount !== undefined &&
            (obj.rotateCount = Math.round(message.rotateCount));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVByteOperation();
        message.operationType = (_a = object.operationType) !== null && _a !== void 0 ? _a : 0;
        message.subBytes = (_b = object.subBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.swapLeftCount = (_c = object.swapLeftCount) !== null && _c !== void 0 ? _c : 0;
        message.shiftCount = (_d = object.shiftCount) !== null && _d !== void 0 ? _d : 0;
        message.rotateCount = (_e = object.rotateCount) !== null && _e !== void 0 ? _e : 0;
        return message;
    }
};
function createBaseVBitwiseOperationList() {
    return { operations: [], rounds: 0 };
}
export const VBitwiseOperationList = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.operations) {
            VByteOperation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.rounds !== 0) {
            writer.uint32(16).int32(message.rounds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVBitwiseOperationList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operations.push(VByteOperation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.rounds = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operations: Array.isArray(object === null || object === void 0 ? void 0 : object.operations)
                ? object.operations.map((e) => VByteOperation.fromJSON(e))
                : [],
            rounds: isSet(object.rounds) ? Number(object.rounds) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.operations) {
            obj.operations = message.operations.map((e) => e ? VByteOperation.toJSON(e) : undefined);
        }
        else {
            obj.operations = [];
        }
        message.rounds !== undefined && (obj.rounds = Math.round(message.rounds));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVBitwiseOperationList();
        message.operations =
            ((_a = object.operations) === null || _a === void 0 ? void 0 : _a.map((e) => VByteOperation.fromPartial(e))) || [];
        message.rounds = (_b = object.rounds) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function createBaseVClientPublicKeyRequest() {
    return { clientPublicKey: undefined, sessionId: 0 };
}
export const VClientPublicKeyRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientPublicKey !== undefined) {
            VCryptoKey.encode(message.clientPublicKey, writer.uint32(10).fork()).ldelim();
        }
        if (message.sessionId !== 0) {
            writer.uint32(16).int64(message.sessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVClientPublicKeyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientPublicKey = VCryptoKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sessionId = longToNumber(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientPublicKey: isSet(object.clientPublicKey)
                ? VCryptoKey.fromJSON(object.clientPublicKey)
                : undefined,
            sessionId: isSet(object.sessionId) ? Number(object.sessionId) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientPublicKey !== undefined &&
            (obj.clientPublicKey = message.clientPublicKey
                ? VCryptoKey.toJSON(message.clientPublicKey)
                : undefined);
        message.sessionId !== undefined &&
            (obj.sessionId = Math.round(message.sessionId));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVClientPublicKeyRequest();
        message.clientPublicKey =
            object.clientPublicKey !== undefined && object.clientPublicKey !== null
                ? VCryptoKey.fromPartial(object.clientPublicKey)
                : undefined;
        message.sessionId = (_a = object.sessionId) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVClientPublicKeyResponse() {
    return {
        response: undefined,
        sessionKey: new Uint8Array(),
        signature: undefined
    };
}
export const VClientPublicKeyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.sessionKey.length !== 0) {
            writer.uint32(18).bytes(message.sessionKey);
        }
        if (message.signature !== undefined) {
            VSignature.encode(message.signature, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVClientPublicKeyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sessionKey = reader.bytes();
                    break;
                case 3:
                    message.signature = VSignature.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            sessionKey: isSet(object.sessionKey)
                ? bytesFromBase64(object.sessionKey)
                : new Uint8Array(),
            signature: isSet(object.signature)
                ? VSignature.fromJSON(object.signature)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.sessionKey !== undefined &&
            (obj.sessionKey = base64FromBytes(message.sessionKey !== undefined ? message.sessionKey : new Uint8Array()));
        message.signature !== undefined &&
            (obj.signature = message.signature
                ? VSignature.toJSON(message.signature)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVClientPublicKeyResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.sessionKey = (_a = object.sessionKey) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? VSignature.fromPartial(object.signature)
                : undefined;
        return message;
    }
};
function createBaseVCryptoKey() {
    return {
        keyId: 0,
        publicKey: '',
        status: 0,
        type: 0,
        creationDate: undefined,
        algorithm: 0,
        keySize: 0,
        hashFunction: 0,
        mgf1HashFunction: 0
    };
}
export const VCryptoKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.keyId !== 0) {
            writer.uint32(8).int32(message.keyId);
        }
        if (message.publicKey !== '') {
            writer.uint32(18).string(message.publicKey);
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.type !== 0) {
            writer.uint32(32).int32(message.type);
        }
        if (message.creationDate !== undefined) {
            VDateTime.encode(message.creationDate, writer.uint32(42).fork()).ldelim();
        }
        if (message.algorithm !== 0) {
            writer.uint32(48).int32(message.algorithm);
        }
        if (message.keySize !== 0) {
            writer.uint32(56).int32(message.keySize);
        }
        if (message.hashFunction !== 0) {
            writer.uint32(64).int32(message.hashFunction);
        }
        if (message.mgf1HashFunction !== 0) {
            writer.uint32(72).int32(message.mgf1HashFunction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVCryptoKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyId = reader.int32();
                    break;
                case 2:
                    message.publicKey = reader.string();
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.type = reader.int32();
                    break;
                case 5:
                    message.creationDate = VDateTime.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.algorithm = reader.int32();
                    break;
                case 7:
                    message.keySize = reader.int32();
                    break;
                case 8:
                    message.hashFunction = reader.int32();
                    break;
                case 9:
                    message.mgf1HashFunction = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            keyId: isSet(object.keyId) ? Number(object.keyId) : 0,
            publicKey: isSet(object.publicKey) ? String(object.publicKey) : '',
            status: isSet(object.status)
                ? vCryptoKey_VCryptoKeyStatusFromJSON(object.status)
                : 0,
            type: isSet(object.type)
                ? vCryptoKey_VCryptoKeyTypeFromJSON(object.type)
                : 0,
            creationDate: isSet(object.creationDate)
                ? VDateTime.fromJSON(object.creationDate)
                : undefined,
            algorithm: isSet(object.algorithm)
                ? vCryptoAlgorithmFromJSON(object.algorithm)
                : 0,
            keySize: isSet(object.keySize) ? Number(object.keySize) : 0,
            hashFunction: isSet(object.hashFunction)
                ? vCryptoHashFunctionFromJSON(object.hashFunction)
                : 0,
            mgf1HashFunction: isSet(object.mgf1HashFunction)
                ? vCryptoHashFunctionFromJSON(object.mgf1HashFunction)
                : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.keyId !== undefined && (obj.keyId = Math.round(message.keyId));
        message.publicKey !== undefined && (obj.publicKey = message.publicKey);
        message.status !== undefined &&
            (obj.status = vCryptoKey_VCryptoKeyStatusToJSON(message.status));
        message.type !== undefined &&
            (obj.type = vCryptoKey_VCryptoKeyTypeToJSON(message.type));
        message.creationDate !== undefined &&
            (obj.creationDate = message.creationDate
                ? VDateTime.toJSON(message.creationDate)
                : undefined);
        message.algorithm !== undefined &&
            (obj.algorithm = vCryptoAlgorithmToJSON(message.algorithm));
        message.keySize !== undefined &&
            (obj.keySize = Math.round(message.keySize));
        message.hashFunction !== undefined &&
            (obj.hashFunction = vCryptoHashFunctionToJSON(message.hashFunction));
        message.mgf1HashFunction !== undefined &&
            (obj.mgf1HashFunction = vCryptoHashFunctionToJSON(message.mgf1HashFunction));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseVCryptoKey();
        message.keyId = (_a = object.keyId) !== null && _a !== void 0 ? _a : 0;
        message.publicKey = (_b = object.publicKey) !== null && _b !== void 0 ? _b : '';
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.type = (_d = object.type) !== null && _d !== void 0 ? _d : 0;
        message.creationDate =
            object.creationDate !== undefined && object.creationDate !== null
                ? VDateTime.fromPartial(object.creationDate)
                : undefined;
        message.algorithm = (_e = object.algorithm) !== null && _e !== void 0 ? _e : 0;
        message.keySize = (_f = object.keySize) !== null && _f !== void 0 ? _f : 0;
        message.hashFunction = (_g = object.hashFunction) !== null && _g !== void 0 ? _g : 0;
        message.mgf1HashFunction = (_h = object.mgf1HashFunction) !== null && _h !== void 0 ? _h : 0;
        return message;
    }
};
function createBaseVDateTime() {
    return { epochUTC: 0, offset: undefined };
}
export const VDateTime = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.epochUTC !== 0) {
            writer.uint32(8).int64(message.epochUTC);
        }
        if (message.offset !== undefined) {
            VTimeSpan.encode(message.offset, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVDateTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochUTC = longToNumber(reader.int64());
                    break;
                case 2:
                    message.offset = VTimeSpan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            epochUTC: isSet(object.epochUTC) ? Number(object.epochUTC) : 0,
            offset: isSet(object.offset)
                ? VTimeSpan.fromJSON(object.offset)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.epochUTC !== undefined &&
            (obj.epochUTC = Math.round(message.epochUTC));
        message.offset !== undefined &&
            (obj.offset = message.offset
                ? VTimeSpan.toJSON(message.offset)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVDateTime();
        message.epochUTC = (_a = object.epochUTC) !== null && _a !== void 0 ? _a : 0;
        message.offset =
            object.offset !== undefined && object.offset !== null
                ? VTimeSpan.fromPartial(object.offset)
                : undefined;
        return message;
    }
};
function createBaseVDecryptRequest() {
    return {
        fileId: '',
        gps: undefined,
        hash: new Uint8Array(),
        includeAuthorizedUsers: false,
        includeDRM: false,
        manufacturerPublicKey: ''
    };
}
export const VDecryptRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        if (message.gps !== undefined) {
            VGPS.encode(message.gps, writer.uint32(18).fork()).ldelim();
        }
        if (message.hash.length !== 0) {
            writer.uint32(26).bytes(message.hash);
        }
        if (message.includeAuthorizedUsers === true) {
            writer.uint32(32).bool(message.includeAuthorizedUsers);
        }
        if (message.includeDRM === true) {
            writer.uint32(40).bool(message.includeDRM);
        }
        if (message.manufacturerPublicKey !== '') {
            writer.uint32(50).string(message.manufacturerPublicKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVDecryptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                case 2:
                    message.gps = VGPS.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.hash = reader.bytes();
                    break;
                case 4:
                    message.includeAuthorizedUsers = reader.bool();
                    break;
                case 5:
                    message.includeDRM = reader.bool();
                    break;
                case 6:
                    message.manufacturerPublicKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            gps: isSet(object.gps) ? VGPS.fromJSON(object.gps) : undefined,
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(),
            includeAuthorizedUsers: isSet(object.includeAuthorizedUsers)
                ? Boolean(object.includeAuthorizedUsers)
                : false,
            includeDRM: isSet(object.includeDRM) ? Boolean(object.includeDRM) : false,
            manufacturerPublicKey: isSet(object.manufacturerPublicKey)
                ? String(object.manufacturerPublicKey)
                : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.gps !== undefined &&
            (obj.gps = message.gps ? VGPS.toJSON(message.gps) : undefined);
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.includeAuthorizedUsers !== undefined &&
            (obj.includeAuthorizedUsers = message.includeAuthorizedUsers);
        message.includeDRM !== undefined && (obj.includeDRM = message.includeDRM);
        message.manufacturerPublicKey !== undefined &&
            (obj.manufacturerPublicKey = message.manufacturerPublicKey);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVDecryptRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.gps =
            object.gps !== undefined && object.gps !== null
                ? VGPS.fromPartial(object.gps)
                : undefined;
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.includeAuthorizedUsers = (_c = object.includeAuthorizedUsers) !== null && _c !== void 0 ? _c : false;
        message.includeDRM = (_d = object.includeDRM) !== null && _d !== void 0 ? _d : false;
        message.manufacturerPublicKey = (_e = object.manufacturerPublicKey) !== null && _e !== void 0 ? _e : '';
        return message;
    }
};
function createBaseVDecryptResponse() {
    return {
        response: undefined,
        fileId: '',
        serverSeed: undefined,
        qr: undefined,
        authorizedUsers: [],
        drm: undefined,
        author: '',
        allowForward: false,
        sunriseDate: undefined,
        sunsetDate: undefined
    };
}
export const VDecryptResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.fileId !== '') {
            writer.uint32(18).string(message.fileId);
        }
        if (message.serverSeed !== undefined) {
            VServerSeed.encode(message.serverSeed, writer.uint32(26).fork()).ldelim();
        }
        if (message.qr !== undefined) {
            VQR.encode(message.qr, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.authorizedUsers) {
            writer.uint32(42).string(v);
        }
        if (message.drm !== undefined) {
            VDRM.encode(message.drm, writer.uint32(50).fork()).ldelim();
        }
        if (message.author !== '') {
            writer.uint32(58).string(message.author);
        }
        if (message.allowForward === true) {
            writer.uint32(64).bool(message.allowForward);
        }
        if (message.sunriseDate !== undefined) {
            VDateTime.encode(message.sunriseDate, writer.uint32(74).fork()).ldelim();
        }
        if (message.sunsetDate !== undefined) {
            VDateTime.encode(message.sunsetDate, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVDecryptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.fileId = reader.string();
                    break;
                case 3:
                    message.serverSeed = VServerSeed.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.qr = VQR.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.authorizedUsers.push(reader.string());
                    break;
                case 6:
                    message.drm = VDRM.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.author = reader.string();
                    break;
                case 8:
                    message.allowForward = reader.bool();
                    break;
                case 9:
                    message.sunriseDate = VDateTime.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.sunsetDate = VDateTime.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            serverSeed: isSet(object.serverSeed)
                ? VServerSeed.fromJSON(object.serverSeed)
                : undefined,
            qr: isSet(object.qr) ? VQR.fromJSON(object.qr) : undefined,
            authorizedUsers: Array.isArray(object === null || object === void 0 ? void 0 : object.authorizedUsers)
                ? object.authorizedUsers.map((e) => String(e))
                : [],
            drm: isSet(object.drm) ? VDRM.fromJSON(object.drm) : undefined,
            author: isSet(object.author) ? String(object.author) : '',
            allowForward: isSet(object.allowForward)
                ? Boolean(object.allowForward)
                : false,
            sunriseDate: isSet(object.sunriseDate)
                ? VDateTime.fromJSON(object.sunriseDate)
                : undefined,
            sunsetDate: isSet(object.sunsetDate)
                ? VDateTime.fromJSON(object.sunsetDate)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.serverSeed !== undefined &&
            (obj.serverSeed = message.serverSeed
                ? VServerSeed.toJSON(message.serverSeed)
                : undefined);
        message.qr !== undefined &&
            (obj.qr = message.qr ? VQR.toJSON(message.qr) : undefined);
        if (message.authorizedUsers) {
            obj.authorizedUsers = message.authorizedUsers.map((e) => e);
        }
        else {
            obj.authorizedUsers = [];
        }
        message.drm !== undefined &&
            (obj.drm = message.drm ? VDRM.toJSON(message.drm) : undefined);
        message.author !== undefined && (obj.author = message.author);
        message.allowForward !== undefined &&
            (obj.allowForward = message.allowForward);
        message.sunriseDate !== undefined &&
            (obj.sunriseDate = message.sunriseDate
                ? VDateTime.toJSON(message.sunriseDate)
                : undefined);
        message.sunsetDate !== undefined &&
            (obj.sunsetDate = message.sunsetDate
                ? VDateTime.toJSON(message.sunsetDate)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseVDecryptResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.serverSeed =
            object.serverSeed !== undefined && object.serverSeed !== null
                ? VServerSeed.fromPartial(object.serverSeed)
                : undefined;
        message.qr =
            object.qr !== undefined && object.qr !== null
                ? VQR.fromPartial(object.qr)
                : undefined;
        message.authorizedUsers = ((_b = object.authorizedUsers) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.drm =
            object.drm !== undefined && object.drm !== null
                ? VDRM.fromPartial(object.drm)
                : undefined;
        message.author = (_c = object.author) !== null && _c !== void 0 ? _c : '';
        message.allowForward = (_d = object.allowForward) !== null && _d !== void 0 ? _d : false;
        message.sunriseDate =
            object.sunriseDate !== undefined && object.sunriseDate !== null
                ? VDateTime.fromPartial(object.sunriseDate)
                : undefined;
        message.sunsetDate =
            object.sunsetDate !== undefined && object.sunsetDate !== null
                ? VDateTime.fromPartial(object.sunsetDate)
                : undefined;
        return message;
    }
};
function createBaseVDRM() {
    return { allowCopy: false, allowPrint: false, allowSave: false };
}
export const VDRM = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowCopy === true) {
            writer.uint32(8).bool(message.allowCopy);
        }
        if (message.allowPrint === true) {
            writer.uint32(16).bool(message.allowPrint);
        }
        if (message.allowSave === true) {
            writer.uint32(24).bool(message.allowSave);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVDRM();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowCopy = reader.bool();
                    break;
                case 2:
                    message.allowPrint = reader.bool();
                    break;
                case 3:
                    message.allowSave = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowCopy: isSet(object.allowCopy) ? Boolean(object.allowCopy) : false,
            allowPrint: isSet(object.allowPrint) ? Boolean(object.allowPrint) : false,
            allowSave: isSet(object.allowSave) ? Boolean(object.allowSave) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.allowCopy !== undefined && (obj.allowCopy = message.allowCopy);
        message.allowPrint !== undefined && (obj.allowPrint = message.allowPrint);
        message.allowSave !== undefined && (obj.allowSave = message.allowSave);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVDRM();
        message.allowCopy = (_a = object.allowCopy) !== null && _a !== void 0 ? _a : false;
        message.allowPrint = (_b = object.allowPrint) !== null && _b !== void 0 ? _b : false;
        message.allowSave = (_c = object.allowSave) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
function createBaseVGeoCity() {
    return {
        id: 0,
        name: '',
        countryId: 0,
        territoryId: 0,
        isBlocked: false,
        canOverride: false
    };
}
export const VGeoCity = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).int64(message.id);
        }
        if (message.name !== '') {
            writer.uint32(18).string(message.name);
        }
        if (message.countryId !== 0) {
            writer.uint32(24).int32(message.countryId);
        }
        if (message.territoryId !== 0) {
            writer.uint32(32).int64(message.territoryId);
        }
        if (message.isBlocked === true) {
            writer.uint32(40).bool(message.isBlocked);
        }
        if (message.canOverride === true) {
            writer.uint32(48).bool(message.canOverride);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGeoCity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.int64());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.countryId = reader.int32();
                    break;
                case 4:
                    message.territoryId = longToNumber(reader.int64());
                    break;
                case 5:
                    message.isBlocked = reader.bool();
                    break;
                case 6:
                    message.canOverride = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? Number(object.id) : 0,
            name: isSet(object.name) ? String(object.name) : '',
            countryId: isSet(object.countryId) ? Number(object.countryId) : 0,
            territoryId: isSet(object.territoryId) ? Number(object.territoryId) : 0,
            isBlocked: isSet(object.isBlocked) ? Boolean(object.isBlocked) : false,
            canOverride: isSet(object.canOverride)
                ? Boolean(object.canOverride)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = Math.round(message.id));
        message.name !== undefined && (obj.name = message.name);
        message.countryId !== undefined &&
            (obj.countryId = Math.round(message.countryId));
        message.territoryId !== undefined &&
            (obj.territoryId = Math.round(message.territoryId));
        message.isBlocked !== undefined && (obj.isBlocked = message.isBlocked);
        message.canOverride !== undefined &&
            (obj.canOverride = message.canOverride);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseVGeoCity();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : '';
        message.countryId = (_c = object.countryId) !== null && _c !== void 0 ? _c : 0;
        message.territoryId = (_d = object.territoryId) !== null && _d !== void 0 ? _d : 0;
        message.isBlocked = (_e = object.isBlocked) !== null && _e !== void 0 ? _e : false;
        message.canOverride = (_f = object.canOverride) !== null && _f !== void 0 ? _f : false;
        return message;
    }
};
function createBaseVGeoCountry() {
    return { id: 0, name: '', code: '', isBlocked: false, canOverride: false };
}
export const VGeoCountry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.name !== '') {
            writer.uint32(18).string(message.name);
        }
        if (message.code !== '') {
            writer.uint32(26).string(message.code);
        }
        if (message.isBlocked === true) {
            writer.uint32(32).bool(message.isBlocked);
        }
        if (message.canOverride === true) {
            writer.uint32(40).bool(message.canOverride);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGeoCountry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.int32();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.code = reader.string();
                    break;
                case 4:
                    message.isBlocked = reader.bool();
                    break;
                case 5:
                    message.canOverride = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? Number(object.id) : 0,
            name: isSet(object.name) ? String(object.name) : '',
            code: isSet(object.code) ? String(object.code) : '',
            isBlocked: isSet(object.isBlocked) ? Boolean(object.isBlocked) : false,
            canOverride: isSet(object.canOverride)
                ? Boolean(object.canOverride)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = Math.round(message.id));
        message.name !== undefined && (obj.name = message.name);
        message.code !== undefined && (obj.code = message.code);
        message.isBlocked !== undefined && (obj.isBlocked = message.isBlocked);
        message.canOverride !== undefined &&
            (obj.canOverride = message.canOverride);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVGeoCountry();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : '';
        message.code = (_c = object.code) !== null && _c !== void 0 ? _c : '';
        message.isBlocked = (_d = object.isBlocked) !== null && _d !== void 0 ? _d : false;
        message.canOverride = (_e = object.canOverride) !== null && _e !== void 0 ? _e : false;
        return message;
    }
};
function createBaseVGeoTerritory() {
    return {
        id: 0,
        name: '',
        countryId: 0,
        isBlocked: false,
        canOverride: false
    };
}
export const VGeoTerritory = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).int64(message.id);
        }
        if (message.name !== '') {
            writer.uint32(18).string(message.name);
        }
        if (message.countryId !== 0) {
            writer.uint32(24).int32(message.countryId);
        }
        if (message.isBlocked === true) {
            writer.uint32(32).bool(message.isBlocked);
        }
        if (message.canOverride === true) {
            writer.uint32(40).bool(message.canOverride);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGeoTerritory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.int64());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.countryId = reader.int32();
                    break;
                case 4:
                    message.isBlocked = reader.bool();
                    break;
                case 5:
                    message.canOverride = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? Number(object.id) : 0,
            name: isSet(object.name) ? String(object.name) : '',
            countryId: isSet(object.countryId) ? Number(object.countryId) : 0,
            isBlocked: isSet(object.isBlocked) ? Boolean(object.isBlocked) : false,
            canOverride: isSet(object.canOverride)
                ? Boolean(object.canOverride)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = Math.round(message.id));
        message.name !== undefined && (obj.name = message.name);
        message.countryId !== undefined &&
            (obj.countryId = Math.round(message.countryId));
        message.isBlocked !== undefined && (obj.isBlocked = message.isBlocked);
        message.canOverride !== undefined &&
            (obj.canOverride = message.canOverride);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVGeoTerritory();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : '';
        message.countryId = (_c = object.countryId) !== null && _c !== void 0 ? _c : 0;
        message.isBlocked = (_d = object.isBlocked) !== null && _d !== void 0 ? _d : false;
        message.canOverride = (_e = object.canOverride) !== null && _e !== void 0 ? _e : false;
        return message;
    }
};
function createBaseVFinishEncryptRequest() {
    return {
        allowForward: false,
        authorizedUsers: [],
        drm: undefined,
        fileId: '',
        gps: undefined,
        sunriseDate: undefined,
        sunsetDate: undefined,
        signature: undefined,
        geoFencing: undefined,
        enableDecryptReceipts: false,
        fileName: '',
        multifactorGeolocation: false,
        secureFiles: undefined,
        totalSizeInBytes: 0,
        notesIncluded: false,
        require2FA: false,
        enableDataSharedAlert: false,
        biometricsRequired: false
    };
}
export const VFinishEncryptRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowForward === true) {
            writer.uint32(8).bool(message.allowForward);
        }
        for (const v of message.authorizedUsers) {
            writer.uint32(18).string(v);
        }
        if (message.drm !== undefined) {
            VDRM.encode(message.drm, writer.uint32(26).fork()).ldelim();
        }
        if (message.fileId !== '') {
            writer.uint32(34).string(message.fileId);
        }
        if (message.gps !== undefined) {
            VGPS.encode(message.gps, writer.uint32(42).fork()).ldelim();
        }
        if (message.sunriseDate !== undefined) {
            VDateTime.encode(message.sunriseDate, writer.uint32(50).fork()).ldelim();
        }
        if (message.sunsetDate !== undefined) {
            VDateTime.encode(message.sunsetDate, writer.uint32(58).fork()).ldelim();
        }
        if (message.signature !== undefined) {
            VSignature.encode(message.signature, writer.uint32(66).fork()).ldelim();
        }
        if (message.geoFencing !== undefined) {
            VGeoFencing.encode(message.geoFencing, writer.uint32(74).fork()).ldelim();
        }
        if (message.enableDecryptReceipts === true) {
            writer.uint32(80).bool(message.enableDecryptReceipts);
        }
        if (message.fileName !== '') {
            writer.uint32(90).string(message.fileName);
        }
        if (message.multifactorGeolocation === true) {
            writer.uint32(96).bool(message.multifactorGeolocation);
        }
        if (message.secureFiles !== undefined) {
            VSecureFileIndex.encode(message.secureFiles, writer.uint32(106).fork()).ldelim();
        }
        if (message.totalSizeInBytes !== 0) {
            writer.uint32(112).int64(message.totalSizeInBytes);
        }
        if (message.notesIncluded === true) {
            writer.uint32(120).bool(message.notesIncluded);
        }
        if (message.require2FA === true) {
            writer.uint32(128).bool(message.require2FA);
        }
        if (message.enableDataSharedAlert === true) {
            writer.uint32(136).bool(message.enableDataSharedAlert);
        }
        if (message.biometricsRequired === true) {
            writer.uint32(144).bool(message.biometricsRequired);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVFinishEncryptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowForward = reader.bool();
                    break;
                case 2:
                    message.authorizedUsers.push(reader.string());
                    break;
                case 3:
                    message.drm = VDRM.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.fileId = reader.string();
                    break;
                case 5:
                    message.gps = VGPS.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.sunriseDate = VDateTime.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.sunsetDate = VDateTime.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.signature = VSignature.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.geoFencing = VGeoFencing.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.enableDecryptReceipts = reader.bool();
                    break;
                case 11:
                    message.fileName = reader.string();
                    break;
                case 12:
                    message.multifactorGeolocation = reader.bool();
                    break;
                case 13:
                    message.secureFiles = VSecureFileIndex.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.totalSizeInBytes = longToNumber(reader.int64());
                    break;
                case 15:
                    message.notesIncluded = reader.bool();
                    break;
                case 16:
                    message.require2FA = reader.bool();
                    break;
                case 17:
                    message.enableDataSharedAlert = reader.bool();
                    break;
                case 18:
                    message.biometricsRequired = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowForward: isSet(object.allowForward)
                ? Boolean(object.allowForward)
                : false,
            authorizedUsers: Array.isArray(object === null || object === void 0 ? void 0 : object.authorizedUsers)
                ? object.authorizedUsers.map((e) => String(e))
                : [],
            drm: isSet(object.drm) ? VDRM.fromJSON(object.drm) : undefined,
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            gps: isSet(object.gps) ? VGPS.fromJSON(object.gps) : undefined,
            sunriseDate: isSet(object.sunriseDate)
                ? VDateTime.fromJSON(object.sunriseDate)
                : undefined,
            sunsetDate: isSet(object.sunsetDate)
                ? VDateTime.fromJSON(object.sunsetDate)
                : undefined,
            signature: isSet(object.signature)
                ? VSignature.fromJSON(object.signature)
                : undefined,
            geoFencing: isSet(object.geoFencing)
                ? VGeoFencing.fromJSON(object.geoFencing)
                : undefined,
            enableDecryptReceipts: isSet(object.enableDecryptReceipts)
                ? Boolean(object.enableDecryptReceipts)
                : false,
            fileName: isSet(object.fileName) ? String(object.fileName) : '',
            multifactorGeolocation: isSet(object.multifactorGeolocation)
                ? Boolean(object.multifactorGeolocation)
                : false,
            secureFiles: isSet(object.secureFiles)
                ? VSecureFileIndex.fromJSON(object.secureFiles)
                : undefined,
            totalSizeInBytes: isSet(object.totalSizeInBytes)
                ? Number(object.totalSizeInBytes)
                : 0,
            notesIncluded: isSet(object.notesIncluded)
                ? Boolean(object.notesIncluded)
                : false,
            require2FA: isSet(object.require2FA) ? Boolean(object.require2FA) : false,
            enableDataSharedAlert: isSet(object.enableDataSharedAlert)
                ? Boolean(object.enableDataSharedAlert)
                : false,
            biometricsRequired: isSet(object.biometricsRequired)
                ? Boolean(object.biometricsRequired)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.allowForward !== undefined &&
            (obj.allowForward = message.allowForward);
        if (message.authorizedUsers) {
            obj.authorizedUsers = message.authorizedUsers.map((e) => e);
        }
        else {
            obj.authorizedUsers = [];
        }
        message.drm !== undefined &&
            (obj.drm = message.drm ? VDRM.toJSON(message.drm) : undefined);
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.gps !== undefined &&
            (obj.gps = message.gps ? VGPS.toJSON(message.gps) : undefined);
        message.sunriseDate !== undefined &&
            (obj.sunriseDate = message.sunriseDate
                ? VDateTime.toJSON(message.sunriseDate)
                : undefined);
        message.sunsetDate !== undefined &&
            (obj.sunsetDate = message.sunsetDate
                ? VDateTime.toJSON(message.sunsetDate)
                : undefined);
        message.signature !== undefined &&
            (obj.signature = message.signature
                ? VSignature.toJSON(message.signature)
                : undefined);
        message.geoFencing !== undefined &&
            (obj.geoFencing = message.geoFencing
                ? VGeoFencing.toJSON(message.geoFencing)
                : undefined);
        message.enableDecryptReceipts !== undefined &&
            (obj.enableDecryptReceipts = message.enableDecryptReceipts);
        message.fileName !== undefined && (obj.fileName = message.fileName);
        message.multifactorGeolocation !== undefined &&
            (obj.multifactorGeolocation = message.multifactorGeolocation);
        message.secureFiles !== undefined &&
            (obj.secureFiles = message.secureFiles
                ? VSecureFileIndex.toJSON(message.secureFiles)
                : undefined);
        message.totalSizeInBytes !== undefined &&
            (obj.totalSizeInBytes = Math.round(message.totalSizeInBytes));
        message.notesIncluded !== undefined &&
            (obj.notesIncluded = message.notesIncluded);
        message.require2FA !== undefined && (obj.require2FA = message.require2FA);
        message.enableDataSharedAlert !== undefined &&
            (obj.enableDataSharedAlert = message.enableDataSharedAlert);
        message.biometricsRequired !== undefined &&
            (obj.biometricsRequired = message.biometricsRequired);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseVFinishEncryptRequest();
        message.allowForward = (_a = object.allowForward) !== null && _a !== void 0 ? _a : false;
        message.authorizedUsers = ((_b = object.authorizedUsers) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.drm =
            object.drm !== undefined && object.drm !== null
                ? VDRM.fromPartial(object.drm)
                : undefined;
        message.fileId = (_c = object.fileId) !== null && _c !== void 0 ? _c : '';
        message.gps =
            object.gps !== undefined && object.gps !== null
                ? VGPS.fromPartial(object.gps)
                : undefined;
        message.sunriseDate =
            object.sunriseDate !== undefined && object.sunriseDate !== null
                ? VDateTime.fromPartial(object.sunriseDate)
                : undefined;
        message.sunsetDate =
            object.sunsetDate !== undefined && object.sunsetDate !== null
                ? VDateTime.fromPartial(object.sunsetDate)
                : undefined;
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? VSignature.fromPartial(object.signature)
                : undefined;
        message.geoFencing =
            object.geoFencing !== undefined && object.geoFencing !== null
                ? VGeoFencing.fromPartial(object.geoFencing)
                : undefined;
        message.enableDecryptReceipts = (_d = object.enableDecryptReceipts) !== null && _d !== void 0 ? _d : false;
        message.fileName = (_e = object.fileName) !== null && _e !== void 0 ? _e : '';
        message.multifactorGeolocation = (_f = object.multifactorGeolocation) !== null && _f !== void 0 ? _f : false;
        message.secureFiles =
            object.secureFiles !== undefined && object.secureFiles !== null
                ? VSecureFileIndex.fromPartial(object.secureFiles)
                : undefined;
        message.totalSizeInBytes = (_g = object.totalSizeInBytes) !== null && _g !== void 0 ? _g : 0;
        message.notesIncluded = (_h = object.notesIncluded) !== null && _h !== void 0 ? _h : false;
        message.require2FA = (_j = object.require2FA) !== null && _j !== void 0 ? _j : false;
        message.enableDataSharedAlert = (_k = object.enableDataSharedAlert) !== null && _k !== void 0 ? _k : false;
        message.biometricsRequired = (_l = object.biometricsRequired) !== null && _l !== void 0 ? _l : false;
        return message;
    }
};
function createBaseVFinishEncryptResponse() {
    return { response: undefined };
}
export const VFinishEncryptResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVFinishEncryptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVFinishEncryptResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVGeoFencing() {
    return { countries: [], territories: [], cities: [] };
}
export const VGeoFencing = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.countries) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.territories) {
            writer.int64(v);
        }
        writer.ldelim();
        writer.uint32(26).fork();
        for (const v of message.cities) {
            writer.int64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGeoFencing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.countries.push(reader.int32());
                        }
                    }
                    else {
                        message.countries.push(reader.int32());
                    }
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.territories.push(longToNumber(reader.int64()));
                        }
                    }
                    else {
                        message.territories.push(longToNumber(reader.int64()));
                    }
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.cities.push(longToNumber(reader.int64()));
                        }
                    }
                    else {
                        message.cities.push(longToNumber(reader.int64()));
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            countries: Array.isArray(object === null || object === void 0 ? void 0 : object.countries)
                ? object.countries.map((e) => Number(e))
                : [],
            territories: Array.isArray(object === null || object === void 0 ? void 0 : object.territories)
                ? object.territories.map((e) => Number(e))
                : [],
            cities: Array.isArray(object === null || object === void 0 ? void 0 : object.cities)
                ? object.cities.map((e) => Number(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.countries) {
            obj.countries = message.countries.map((e) => Math.round(e));
        }
        else {
            obj.countries = [];
        }
        if (message.territories) {
            obj.territories = message.territories.map((e) => Math.round(e));
        }
        else {
            obj.territories = [];
        }
        if (message.cities) {
            obj.cities = message.cities.map((e) => Math.round(e));
        }
        else {
            obj.cities = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVGeoFencing();
        message.countries = ((_a = object.countries) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.territories = ((_b = object.territories) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.cities = ((_c = object.cities) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    }
};
function createBaseVGeoItems() {
    return { countries: [], territories: [], cities: [] };
}
export const VGeoItems = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.countries) {
            VGeoCountry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.territories) {
            VGeoTerritory.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.cities) {
            VGeoCity.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGeoItems();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.countries.push(VGeoCountry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.territories.push(VGeoTerritory.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.cities.push(VGeoCity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            countries: Array.isArray(object === null || object === void 0 ? void 0 : object.countries)
                ? object.countries.map((e) => VGeoCountry.fromJSON(e))
                : [],
            territories: Array.isArray(object === null || object === void 0 ? void 0 : object.territories)
                ? object.territories.map((e) => VGeoTerritory.fromJSON(e))
                : [],
            cities: Array.isArray(object === null || object === void 0 ? void 0 : object.cities)
                ? object.cities.map((e) => VGeoCity.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.countries) {
            obj.countries = message.countries.map((e) => e ? VGeoCountry.toJSON(e) : undefined);
        }
        else {
            obj.countries = [];
        }
        if (message.territories) {
            obj.territories = message.territories.map((e) => e ? VGeoTerritory.toJSON(e) : undefined);
        }
        else {
            obj.territories = [];
        }
        if (message.cities) {
            obj.cities = message.cities.map((e) => e ? VGeoCity.toJSON(e) : undefined);
        }
        else {
            obj.cities = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVGeoItems();
        message.countries =
            ((_a = object.countries) === null || _a === void 0 ? void 0 : _a.map((e) => VGeoCountry.fromPartial(e))) || [];
        message.territories =
            ((_b = object.territories) === null || _b === void 0 ? void 0 : _b.map((e) => VGeoTerritory.fromPartial(e))) || [];
        message.cities = ((_c = object.cities) === null || _c === void 0 ? void 0 : _c.map((e) => VGeoCity.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVGPS() {
    return { latitude: '', longitude: '' };
}
export const VGPS = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.latitude !== '') {
            writer.uint32(10).string(message.latitude);
        }
        if (message.longitude !== '') {
            writer.uint32(18).string(message.longitude);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVGPS();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.latitude = reader.string();
                    break;
                case 2:
                    message.longitude = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            latitude: isSet(object.latitude) ? String(object.latitude) : '',
            longitude: isSet(object.longitude) ? String(object.longitude) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.latitude !== undefined && (obj.latitude = message.latitude);
        message.longitude !== undefined && (obj.longitude = message.longitude);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVGPS();
        message.latitude = (_a = object.latitude) !== null && _a !== void 0 ? _a : '';
        message.longitude = (_b = object.longitude) !== null && _b !== void 0 ? _b : '';
        return message;
    }
};
function createBaseVLoginRequest() {
    return { email: '', gps: undefined, password: '', returnUserDetails: false };
}
export const VLoginRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.email !== '') {
            writer.uint32(10).string(message.email);
        }
        if (message.gps !== undefined) {
            VGPS.encode(message.gps, writer.uint32(18).fork()).ldelim();
        }
        if (message.password !== '') {
            writer.uint32(26).string(message.password);
        }
        if (message.returnUserDetails === true) {
            writer.uint32(32).bool(message.returnUserDetails);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVLoginRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                case 2:
                    message.gps = VGPS.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.password = reader.string();
                    break;
                case 4:
                    message.returnUserDetails = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            email: isSet(object.email) ? String(object.email) : '',
            gps: isSet(object.gps) ? VGPS.fromJSON(object.gps) : undefined,
            password: isSet(object.password) ? String(object.password) : '',
            returnUserDetails: isSet(object.returnUserDetails)
                ? Boolean(object.returnUserDetails)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.email !== undefined && (obj.email = message.email);
        message.gps !== undefined &&
            (obj.gps = message.gps ? VGPS.toJSON(message.gps) : undefined);
        message.password !== undefined && (obj.password = message.password);
        message.returnUserDetails !== undefined &&
            (obj.returnUserDetails = message.returnUserDetails);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVLoginRequest();
        message.email = (_a = object.email) !== null && _a !== void 0 ? _a : '';
        message.gps =
            object.gps !== undefined && object.gps !== null
                ? VGPS.fromPartial(object.gps)
                : undefined;
        message.password = (_b = object.password) !== null && _b !== void 0 ? _b : '';
        message.returnUserDetails = (_c = object.returnUserDetails) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
function createBaseVLoginResponse() {
    return { response: undefined, userDetails: undefined };
}
export const VLoginResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.userDetails !== undefined) {
            VUserDetails.encode(message.userDetails, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVLoginResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.userDetails = VUserDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            userDetails: isSet(object.userDetails)
                ? VUserDetails.fromJSON(object.userDetails)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.userDetails !== undefined &&
            (obj.userDetails = message.userDetails
                ? VUserDetails.toJSON(message.userDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVLoginResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.userDetails =
            object.userDetails !== undefined && object.userDetails !== null
                ? VUserDetails.fromPartial(object.userDetails)
                : undefined;
        return message;
    }
};
function createBaseVLogoutRequest() {
    return { logoutAllSessions: false };
}
export const VLogoutRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.logoutAllSessions === true) {
            writer.uint32(8).bool(message.logoutAllSessions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVLogoutRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.logoutAllSessions = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            logoutAllSessions: isSet(object.logoutAllSessions)
                ? Boolean(object.logoutAllSessions)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.logoutAllSessions !== undefined &&
            (obj.logoutAllSessions = message.logoutAllSessions);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVLogoutRequest();
        message.logoutAllSessions = (_a = object.logoutAllSessions) !== null && _a !== void 0 ? _a : false;
        return message;
    }
};
function createBaseVLogoutResponse() {
    return { response: undefined };
}
export const VLogoutResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVLogoutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVLogoutResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVPacket() {
    return {
        contents: new Uint8Array(),
        sessionId: 0,
        iv: new Uint8Array(),
        signature: undefined,
        nonce: ''
    };
}
export const VPacket = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.contents.length !== 0) {
            writer.uint32(10).bytes(message.contents);
        }
        if (message.sessionId !== 0) {
            writer.uint32(16).int64(message.sessionId);
        }
        if (message.iv.length !== 0) {
            writer.uint32(26).bytes(message.iv);
        }
        if (message.signature !== undefined) {
            VSignature.encode(message.signature, writer.uint32(34).fork()).ldelim();
        }
        if (message.nonce !== '') {
            writer.uint32(42).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVPacket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contents = reader.bytes();
                    break;
                case 2:
                    message.sessionId = longToNumber(reader.int64());
                    break;
                case 3:
                    message.iv = reader.bytes();
                    break;
                case 4:
                    message.signature = VSignature.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            contents: isSet(object.contents)
                ? bytesFromBase64(object.contents)
                : new Uint8Array(),
            sessionId: isSet(object.sessionId) ? Number(object.sessionId) : 0,
            iv: isSet(object.iv) ? bytesFromBase64(object.iv) : new Uint8Array(),
            signature: isSet(object.signature)
                ? VSignature.fromJSON(object.signature)
                : undefined,
            nonce: isSet(object.nonce) ? String(object.nonce) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.contents !== undefined &&
            (obj.contents = base64FromBytes(message.contents !== undefined ? message.contents : new Uint8Array()));
        message.sessionId !== undefined &&
            (obj.sessionId = Math.round(message.sessionId));
        message.iv !== undefined &&
            (obj.iv = base64FromBytes(message.iv !== undefined ? message.iv : new Uint8Array()));
        message.signature !== undefined &&
            (obj.signature = message.signature
                ? VSignature.toJSON(message.signature)
                : undefined);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseVPacket();
        message.contents = (_a = object.contents) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.sessionId = (_b = object.sessionId) !== null && _b !== void 0 ? _b : 0;
        message.iv = (_c = object.iv) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? VSignature.fromPartial(object.signature)
                : undefined;
        message.nonce = (_d = object.nonce) !== null && _d !== void 0 ? _d : '';
        return message;
    }
};
function createBaseVPublicKeyRequest() {
    return { availableAlgorithms: [], availableHashFunctions: [], deviceId: '' };
}
export const VPublicKeyRequest = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.availableAlgorithms) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.availableHashFunctions) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.deviceId !== '') {
            writer.uint32(26).string(message.deviceId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVPublicKeyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.availableAlgorithms.push(reader.int32());
                        }
                    }
                    else {
                        message.availableAlgorithms.push(reader.int32());
                    }
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.availableHashFunctions.push(reader.int32());
                        }
                    }
                    else {
                        message.availableHashFunctions.push(reader.int32());
                    }
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            availableAlgorithms: Array.isArray(object === null || object === void 0 ? void 0 : object.availableAlgorithms)
                ? object.availableAlgorithms.map((e) => vCryptoAlgorithmFromJSON(e))
                : [],
            availableHashFunctions: Array.isArray(object === null || object === void 0 ? void 0 : object.availableHashFunctions)
                ? object.availableHashFunctions.map((e) => vCryptoHashFunctionFromJSON(e))
                : [],
            deviceId: isSet(object.deviceId) ? String(object.deviceId) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.availableAlgorithms) {
            obj.availableAlgorithms = message.availableAlgorithms.map((e) => vCryptoAlgorithmToJSON(e));
        }
        else {
            obj.availableAlgorithms = [];
        }
        if (message.availableHashFunctions) {
            obj.availableHashFunctions = message.availableHashFunctions.map((e) => vCryptoHashFunctionToJSON(e));
        }
        else {
            obj.availableHashFunctions = [];
        }
        message.deviceId !== undefined && (obj.deviceId = message.deviceId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVPublicKeyRequest();
        message.availableAlgorithms =
            ((_a = object.availableAlgorithms) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.availableHashFunctions =
            ((_b = object.availableHashFunctions) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.deviceId = (_c = object.deviceId) !== null && _c !== void 0 ? _c : '';
        return message;
    }
};
function createBaseVPublicKeyResponse() {
    return {
        response: undefined,
        serverPublicKey: undefined,
        sessionId: 0,
        signature: undefined
    };
}
export const VPublicKeyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.serverPublicKey !== undefined) {
            VCryptoKey.encode(message.serverPublicKey, writer.uint32(18).fork()).ldelim();
        }
        if (message.sessionId !== 0) {
            writer.uint32(24).int64(message.sessionId);
        }
        if (message.signature !== undefined) {
            VSignature.encode(message.signature, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVPublicKeyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.serverPublicKey = VCryptoKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sessionId = longToNumber(reader.int64());
                    break;
                case 4:
                    message.signature = VSignature.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            serverPublicKey: isSet(object.serverPublicKey)
                ? VCryptoKey.fromJSON(object.serverPublicKey)
                : undefined,
            sessionId: isSet(object.sessionId) ? Number(object.sessionId) : 0,
            signature: isSet(object.signature)
                ? VSignature.fromJSON(object.signature)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.serverPublicKey !== undefined &&
            (obj.serverPublicKey = message.serverPublicKey
                ? VCryptoKey.toJSON(message.serverPublicKey)
                : undefined);
        message.sessionId !== undefined &&
            (obj.sessionId = Math.round(message.sessionId));
        message.signature !== undefined &&
            (obj.signature = message.signature
                ? VSignature.toJSON(message.signature)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVPublicKeyResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.serverPublicKey =
            object.serverPublicKey !== undefined && object.serverPublicKey !== null
                ? VCryptoKey.fromPartial(object.serverPublicKey)
                : undefined;
        message.sessionId = (_a = object.sessionId) !== null && _a !== void 0 ? _a : 0;
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? VSignature.fromPartial(object.signature)
                : undefined;
        return message;
    }
};
function createBaseVQR() {
    return { qrId: 0, qrImage: new Uint8Array(), format: 0 };
}
export const VQR = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.qrId !== 0) {
            writer.uint32(8).int64(message.qrId);
        }
        if (message.qrImage.length !== 0) {
            writer.uint32(18).bytes(message.qrImage);
        }
        if (message.format !== 0) {
            writer.uint32(24).int32(message.format);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVQR();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.qrId = longToNumber(reader.int64());
                    break;
                case 2:
                    message.qrImage = reader.bytes();
                    break;
                case 3:
                    message.format = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            qrId: isSet(object.qrId) ? Number(object.qrId) : 0,
            qrImage: isSet(object.qrImage)
                ? bytesFromBase64(object.qrImage)
                : new Uint8Array(),
            format: isSet(object.format) ? vImageFormatFromJSON(object.format) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.qrId !== undefined && (obj.qrId = Math.round(message.qrId));
        message.qrImage !== undefined &&
            (obj.qrImage = base64FromBytes(message.qrImage !== undefined ? message.qrImage : new Uint8Array()));
        message.format !== undefined &&
            (obj.format = vImageFormatToJSON(message.format));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVQR();
        message.qrId = (_a = object.qrId) !== null && _a !== void 0 ? _a : 0;
        message.qrImage = (_b = object.qrImage) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.format = (_c = object.format) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function createBaseVQRStatusRequest() {
    return { qrId: 0 };
}
export const VQRStatusRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.qrId !== 0) {
            writer.uint32(8).int64(message.qrId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVQRStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.qrId = longToNumber(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            qrId: isSet(object.qrId) ? Number(object.qrId) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.qrId !== undefined && (obj.qrId = Math.round(message.qrId));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVQRStatusRequest();
        message.qrId = (_a = object.qrId) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVQRStatusResponse() {
    return { response: undefined, status: 0 };
}
export const VQRStatusResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(16).int32(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVQRStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            status: isSet(object.status) ? qRStatusFromJSON(object.status) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.status !== undefined &&
            (obj.status = qRStatusToJSON(message.status));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVQRStatusResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVQRVerificationRequest() {
    return { qrCode: '', gps: undefined, biometricPublicKey: '' };
}
export const VQRVerificationRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.qrCode !== '') {
            writer.uint32(10).string(message.qrCode);
        }
        if (message.gps !== undefined) {
            VGPS.encode(message.gps, writer.uint32(18).fork()).ldelim();
        }
        if (message.biometricPublicKey !== '') {
            writer.uint32(26).string(message.biometricPublicKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVQRVerificationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.qrCode = reader.string();
                    break;
                case 2:
                    message.gps = VGPS.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.biometricPublicKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            qrCode: isSet(object.qrCode) ? String(object.qrCode) : '',
            gps: isSet(object.gps) ? VGPS.fromJSON(object.gps) : undefined,
            biometricPublicKey: isSet(object.biometricPublicKey)
                ? String(object.biometricPublicKey)
                : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.qrCode !== undefined && (obj.qrCode = message.qrCode);
        message.gps !== undefined &&
            (obj.gps = message.gps ? VGPS.toJSON(message.gps) : undefined);
        message.biometricPublicKey !== undefined &&
            (obj.biometricPublicKey = message.biometricPublicKey);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVQRVerificationRequest();
        message.qrCode = (_a = object.qrCode) !== null && _a !== void 0 ? _a : '';
        message.gps =
            object.gps !== undefined && object.gps !== null
                ? VGPS.fromPartial(object.gps)
                : undefined;
        message.biometricPublicKey = (_b = object.biometricPublicKey) !== null && _b !== void 0 ? _b : '';
        return message;
    }
};
function createBaseVQRVerificationResponse() {
    return { response: undefined };
}
export const VQRVerificationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVQRVerificationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVQRVerificationResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVEmailVerifyRequest() {
    return { email: '' };
}
export const VEmailVerifyRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.email !== '') {
            writer.uint32(10).string(message.email);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVEmailVerifyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            email: isSet(object.email) ? String(object.email) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.email !== undefined && (obj.email = message.email);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVEmailVerifyRequest();
        message.email = (_a = object.email) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVEmailVerifyResponse() {
    return { response: undefined, code: 0 };
}
export const VEmailVerifyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.code !== 0) {
            writer.uint32(16).int32(message.code);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVEmailVerifyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.code = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            code: isSet(object.code)
                ? vEmailVerifyResponse_VEmailVerifyResponseCodeFromJSON(object.code)
                : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.code !== undefined &&
            (obj.code = vEmailVerifyResponse_VEmailVerifyResponseCodeToJSON(message.code));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVEmailVerifyResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVResponse() {
    return { code: 0, text: '' };
}
export const VResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.code !== 0) {
            writer.uint32(8).int32(message.code);
        }
        if (message.text !== '') {
            writer.uint32(18).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.int32();
                    break;
                case 2:
                    message.text = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? vResponseCodeFromJSON(object.code) : 0,
            text: isSet(object.text) ? String(object.text) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined &&
            (obj.code = vResponseCodeToJSON(message.code));
        message.text !== undefined && (obj.text = message.text);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVResponse();
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : '';
        return message;
    }
};
function createBaseVSecureFile() {
    return { header: undefined, index: new Uint8Array(), partitions: [] };
}
export const VSecureFile = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.header !== undefined) {
            VSecureFileHeader.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        if (message.index.length !== 0) {
            writer.uint32(18).bytes(message.index);
        }
        for (const v of message.partitions) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = VSecureFileHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.index = reader.bytes();
                    break;
                case 3:
                    message.partitions.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: isSet(object.header)
                ? VSecureFileHeader.fromJSON(object.header)
                : undefined,
            index: isSet(object.index)
                ? bytesFromBase64(object.index)
                : new Uint8Array(),
            partitions: Array.isArray(object === null || object === void 0 ? void 0 : object.partitions)
                ? object.partitions.map((e) => bytesFromBase64(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined &&
            (obj.header = message.header
                ? VSecureFileHeader.toJSON(message.header)
                : undefined);
        message.index !== undefined &&
            (obj.index = base64FromBytes(message.index !== undefined ? message.index : new Uint8Array()));
        if (message.partitions) {
            obj.partitions = message.partitions.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.partitions = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVSecureFile();
        message.header =
            object.header !== undefined && object.header !== null
                ? VSecureFileHeader.fromPartial(object.header)
                : undefined;
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.partitions = ((_b = object.partitions) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    }
};
function createBaseVSecureFileHeader() {
    return {
        fileId: '',
        endpointUrl: '',
        version: '',
        hashFunction: 0,
        seed: new Uint8Array(),
        seedIv: new Uint8Array(),
        description: ''
    };
}
export const VSecureFileHeader = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        if (message.endpointUrl !== '') {
            writer.uint32(18).string(message.endpointUrl);
        }
        if (message.version !== '') {
            writer.uint32(26).string(message.version);
        }
        if (message.hashFunction !== 0) {
            writer.uint32(32).int32(message.hashFunction);
        }
        if (message.seed.length !== 0) {
            writer.uint32(42).bytes(message.seed);
        }
        if (message.seedIv.length !== 0) {
            writer.uint32(50).bytes(message.seedIv);
        }
        if (message.description !== '') {
            writer.uint32(58).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                case 2:
                    message.endpointUrl = reader.string();
                    break;
                case 3:
                    message.version = reader.string();
                    break;
                case 4:
                    message.hashFunction = reader.int32();
                    break;
                case 5:
                    message.seed = reader.bytes();
                    break;
                case 6:
                    message.seedIv = reader.bytes();
                    break;
                case 7:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            endpointUrl: isSet(object.endpointUrl) ? String(object.endpointUrl) : '',
            version: isSet(object.version) ? String(object.version) : '',
            hashFunction: isSet(object.hashFunction)
                ? vCryptoHashFunctionFromJSON(object.hashFunction)
                : 0,
            seed: isSet(object.seed)
                ? bytesFromBase64(object.seed)
                : new Uint8Array(),
            seedIv: isSet(object.seedIv)
                ? bytesFromBase64(object.seedIv)
                : new Uint8Array(),
            description: isSet(object.description) ? String(object.description) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.endpointUrl !== undefined &&
            (obj.endpointUrl = message.endpointUrl);
        message.version !== undefined && (obj.version = message.version);
        message.hashFunction !== undefined &&
            (obj.hashFunction = vCryptoHashFunctionToJSON(message.hashFunction));
        message.seed !== undefined &&
            (obj.seed = base64FromBytes(message.seed !== undefined ? message.seed : new Uint8Array()));
        message.seedIv !== undefined &&
            (obj.seedIv = base64FromBytes(message.seedIv !== undefined ? message.seedIv : new Uint8Array()));
        message.description !== undefined &&
            (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseVSecureFileHeader();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.endpointUrl = (_b = object.endpointUrl) !== null && _b !== void 0 ? _b : '';
        message.version = (_c = object.version) !== null && _c !== void 0 ? _c : '';
        message.hashFunction = (_d = object.hashFunction) !== null && _d !== void 0 ? _d : 0;
        message.seed = (_e = object.seed) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.seedIv = (_f = object.seedIv) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.description = (_g = object.description) !== null && _g !== void 0 ? _g : '';
        return message;
    }
};
function createBaseVSecureFileIndex() {
    return { preferredItemIndex: 0, items: [] };
}
export const VSecureFileIndex = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.preferredItemIndex !== 0) {
            writer.uint32(8).int32(message.preferredItemIndex);
        }
        for (const v of message.items) {
            VSecureFileIndexItem.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileIndex();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.preferredItemIndex = reader.int32();
                    break;
                case 2:
                    message.items.push(VSecureFileIndexItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            preferredItemIndex: isSet(object.preferredItemIndex)
                ? Number(object.preferredItemIndex)
                : 0,
            items: Array.isArray(object === null || object === void 0 ? void 0 : object.items)
                ? object.items.map((e) => VSecureFileIndexItem.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.preferredItemIndex !== undefined &&
            (obj.preferredItemIndex = Math.round(message.preferredItemIndex));
        if (message.items) {
            obj.items = message.items.map((e) => e ? VSecureFileIndexItem.toJSON(e) : undefined);
        }
        else {
            obj.items = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVSecureFileIndex();
        message.preferredItemIndex = (_a = object.preferredItemIndex) !== null && _a !== void 0 ? _a : 0;
        message.items =
            ((_b = object.items) === null || _b === void 0 ? void 0 : _b.map((e) => VSecureFileIndexItem.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVSecureFileIndexItem() {
    return {
        name: '',
        type: 0,
        extension: '',
        sizeInBytes: 0,
        hash: new Uint8Array(),
        hashFunction: 0
    };
}
export const VSecureFileIndexItem = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== '') {
            writer.uint32(10).string(message.name);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        if (message.extension !== '') {
            writer.uint32(26).string(message.extension);
        }
        if (message.sizeInBytes !== 0) {
            writer.uint32(32).int64(message.sizeInBytes);
        }
        if (message.hash.length !== 0) {
            writer.uint32(42).bytes(message.hash);
        }
        if (message.hashFunction !== 0) {
            writer.uint32(48).int32(message.hashFunction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileIndexItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                case 3:
                    message.extension = reader.string();
                    break;
                case 4:
                    message.sizeInBytes = longToNumber(reader.int64());
                    break;
                case 5:
                    message.hash = reader.bytes();
                    break;
                case 6:
                    message.hashFunction = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? String(object.name) : '',
            type: isSet(object.type)
                ? vSecureFilePartitionTypeFromJSON(object.type)
                : 0,
            extension: isSet(object.extension) ? String(object.extension) : '',
            sizeInBytes: isSet(object.sizeInBytes) ? Number(object.sizeInBytes) : 0,
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(),
            hashFunction: isSet(object.hashFunction)
                ? vCryptoHashFunctionFromJSON(object.hashFunction)
                : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.type !== undefined &&
            (obj.type = vSecureFilePartitionTypeToJSON(message.type));
        message.extension !== undefined && (obj.extension = message.extension);
        message.sizeInBytes !== undefined &&
            (obj.sizeInBytes = Math.round(message.sizeInBytes));
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.hashFunction !== undefined &&
            (obj.hashFunction = vCryptoHashFunctionToJSON(message.hashFunction));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseVSecureFileIndexItem();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : '';
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : 0;
        message.extension = (_c = object.extension) !== null && _c !== void 0 ? _c : '';
        message.sizeInBytes = (_d = object.sizeInBytes) !== null && _d !== void 0 ? _d : 0;
        message.hash = (_e = object.hash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.hashFunction = (_f = object.hashFunction) !== null && _f !== void 0 ? _f : 0;
        return message;
    }
};
function createBaseVSecureFilePartition() {
    return { name: '', type: 0, extension: '', contents: new Uint8Array() };
}
export const VSecureFilePartition = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== '') {
            writer.uint32(10).string(message.name);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        if (message.extension !== '') {
            writer.uint32(26).string(message.extension);
        }
        if (message.contents.length !== 0) {
            writer.uint32(34).bytes(message.contents);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFilePartition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                case 3:
                    message.extension = reader.string();
                    break;
                case 4:
                    message.contents = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? String(object.name) : '',
            type: isSet(object.type)
                ? vSecureFilePartitionTypeFromJSON(object.type)
                : 0,
            extension: isSet(object.extension) ? String(object.extension) : '',
            contents: isSet(object.contents)
                ? bytesFromBase64(object.contents)
                : new Uint8Array()
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.type !== undefined &&
            (obj.type = vSecureFilePartitionTypeToJSON(message.type));
        message.extension !== undefined && (obj.extension = message.extension);
        message.contents !== undefined &&
            (obj.contents = base64FromBytes(message.contents !== undefined ? message.contents : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseVSecureFilePartition();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : '';
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : 0;
        message.extension = (_c = object.extension) !== null && _c !== void 0 ? _c : '';
        message.contents = (_d = object.contents) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function createBaseVSecureFileGeofencingItemsRequest() {
    return { fileId: '' };
}
export const VSecureFileGeofencingItemsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileGeofencingItemsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileGeofencingItemsRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVSecureFileGeofencingItemsResponse() {
    return { response: undefined, geoItems: undefined };
}
export const VSecureFileGeofencingItemsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.geoItems !== undefined) {
            VGeoItems.encode(message.geoItems, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileGeofencingItemsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.geoItems = VGeoItems.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            geoItems: isSet(object.geoItems)
                ? VGeoItems.fromJSON(object.geoItems)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.geoItems !== undefined &&
            (obj.geoItems = message.geoItems
                ? VGeoItems.toJSON(message.geoItems)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVSecureFileGeofencingItemsResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.geoItems =
            object.geoItems !== undefined && object.geoItems !== null
                ? VGeoItems.fromPartial(object.geoItems)
                : undefined;
        return message;
    }
};
function createBaseVSecureFileRevokeRequest() {
    return { fileId: '' };
}
export const VSecureFileRevokeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileRevokeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileRevokeRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVSecureFileRevokeResponse() {
    return { response: undefined };
}
export const VSecureFileRevokeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileRevokeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVSecureFileRevokeResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVSecureFileShredRequest() {
    return { fileId: '' };
}
export const VSecureFileShredRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileShredRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileShredRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVSecureFileShredResponse() {
    return { response: undefined };
}
export const VSecureFileShredResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileShredResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVSecureFileShredResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVSecureFileAuthorizedUsersRequest() {
    return { fileId: '' };
}
export const VSecureFileAuthorizedUsersRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileAuthorizedUsersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileAuthorizedUsersRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVSecureFileAuthorizedUsersResponse() {
    return { response: undefined, authorizedUsers: [] };
}
export const VSecureFileAuthorizedUsersResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.authorizedUsers) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileAuthorizedUsersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authorizedUsers.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            authorizedUsers: Array.isArray(object === null || object === void 0 ? void 0 : object.authorizedUsers)
                ? object.authorizedUsers.map((e) => String(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        if (message.authorizedUsers) {
            obj.authorizedUsers = message.authorizedUsers.map((e) => e);
        }
        else {
            obj.authorizedUsers = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileAuthorizedUsersResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.authorizedUsers = ((_a = object.authorizedUsers) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    }
};
function createBaseVSecureFileUserAccessRequest() {
    return { fileId: '', users: [] };
}
export const VSecureFileUserAccessRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        for (const v of message.users) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileUserAccessRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                case 2:
                    message.users.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            users: Array.isArray(object === null || object === void 0 ? void 0 : object.users)
                ? object.users.map((e) => String(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        if (message.users) {
            obj.users = message.users.map((e) => e);
        }
        else {
            obj.users = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVSecureFileUserAccessRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.users = ((_b = object.users) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    }
};
function createBaseVSecureFileUserAccessResponse() {
    return { response: undefined, users: [] };
}
export const VSecureFileUserAccessResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.users) {
            VSecureFileUserAccessResponse_VSecureFileUserAccessItem.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileUserAccessResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.users.push(VSecureFileUserAccessResponse_VSecureFileUserAccessItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            users: Array.isArray(object === null || object === void 0 ? void 0 : object.users)
                ? object.users.map((e) => VSecureFileUserAccessResponse_VSecureFileUserAccessItem.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        if (message.users) {
            obj.users = message.users.map((e) => e
                ? VSecureFileUserAccessResponse_VSecureFileUserAccessItem.toJSON(e)
                : undefined);
        }
        else {
            obj.users = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileUserAccessResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.users =
            ((_a = object.users) === null || _a === void 0 ? void 0 : _a.map((e) => VSecureFileUserAccessResponse_VSecureFileUserAccessItem.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVSecureFileUserAccessResponse_VSecureFileUserAccessItem() {
    return { user: '', access: false, isAuthor: false };
}
export const VSecureFileUserAccessResponse_VSecureFileUserAccessItem = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.user !== '') {
            writer.uint32(10).string(message.user);
        }
        if (message.access === true) {
            writer.uint32(16).bool(message.access);
        }
        if (message.isAuthor === true) {
            writer.uint32(24).bool(message.isAuthor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileUserAccessResponse_VSecureFileUserAccessItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.user = reader.string();
                    break;
                case 2:
                    message.access = reader.bool();
                    break;
                case 3:
                    message.isAuthor = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            user: isSet(object.user) ? String(object.user) : '',
            access: isSet(object.access) ? Boolean(object.access) : false,
            isAuthor: isSet(object.isAuthor) ? Boolean(object.isAuthor) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user);
        message.access !== undefined && (obj.access = message.access);
        message.isAuthor !== undefined && (obj.isAuthor = message.isAuthor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVSecureFileUserAccessResponse_VSecureFileUserAccessItem();
        message.user = (_a = object.user) !== null && _a !== void 0 ? _a : '';
        message.access = (_b = object.access) !== null && _b !== void 0 ? _b : false;
        message.isAuthor = (_c = object.isAuthor) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
function createBaseVSecureFileVerifyHashRequest() {
    return { fileId: '', hash: new Uint8Array() };
}
export const VSecureFileVerifyHashRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fileId !== '') {
            writer.uint32(10).string(message.fileId);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileVerifyHashRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fileId = reader.string();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array()
        };
    },
    toJSON(message) {
        const obj = {};
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVSecureFileVerifyHashRequest();
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function createBaseVSecureFileVerifyHashResponse() {
    return { verified: false };
}
export const VSecureFileVerifyHashResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.verified === true) {
            writer.uint32(8).bool(message.verified);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSecureFileVerifyHashResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.verified = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            verified: isSet(object.verified) ? Boolean(object.verified) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.verified !== undefined && (obj.verified = message.verified);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVSecureFileVerifyHashResponse();
        message.verified = (_a = object.verified) !== null && _a !== void 0 ? _a : false;
        return message;
    }
};
function createBaseVSignature() {
    return { hash: new Uint8Array(), function: 0 };
}
export const VSignature = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        if (message.function !== 0) {
            writer.uint32(16).int32(message.function);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSignature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.function = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(),
            function: isSet(object.function)
                ? vCryptoHashFunctionFromJSON(object.function)
                : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.function !== undefined &&
            (obj.function = vCryptoHashFunctionToJSON(message.function));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVSignature();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.function = (_b = object.function) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function createBaseVSoftwareRequest() {
    return { softwareFamily: '', version: '', isBeta: false };
}
export const VSoftwareRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.softwareFamily !== '') {
            writer.uint32(10).string(message.softwareFamily);
        }
        if (message.version !== '') {
            writer.uint32(18).string(message.version);
        }
        if (message.isBeta === true) {
            writer.uint32(24).bool(message.isBeta);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSoftwareRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.softwareFamily = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.isBeta = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            softwareFamily: isSet(object.softwareFamily)
                ? String(object.softwareFamily)
                : '',
            version: isSet(object.version) ? String(object.version) : '',
            isBeta: isSet(object.isBeta) ? Boolean(object.isBeta) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.softwareFamily !== undefined &&
            (obj.softwareFamily = message.softwareFamily);
        message.version !== undefined && (obj.version = message.version);
        message.isBeta !== undefined && (obj.isBeta = message.isBeta);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVSoftwareRequest();
        message.softwareFamily = (_a = object.softwareFamily) !== null && _a !== void 0 ? _a : '';
        message.version = (_b = object.version) !== null && _b !== void 0 ? _b : '';
        message.isBeta = (_c = object.isBeta) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
function createBaseVSoftwareResponse() {
    return {
        response: undefined,
        softwareVersion: undefined,
        signature: undefined
    };
}
export const VSoftwareResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.softwareVersion !== undefined) {
            VSoftwareVersion.encode(message.softwareVersion, writer.uint32(18).fork()).ldelim();
        }
        if (message.signature !== undefined) {
            VSignature.encode(message.signature, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSoftwareResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.softwareVersion = VSoftwareVersion.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signature = VSignature.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            softwareVersion: isSet(object.softwareVersion)
                ? VSoftwareVersion.fromJSON(object.softwareVersion)
                : undefined,
            signature: isSet(object.signature)
                ? VSignature.fromJSON(object.signature)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.softwareVersion !== undefined &&
            (obj.softwareVersion = message.softwareVersion
                ? VSoftwareVersion.toJSON(message.softwareVersion)
                : undefined);
        message.signature !== undefined &&
            (obj.signature = message.signature
                ? VSignature.toJSON(message.signature)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVSoftwareResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.softwareVersion =
            object.softwareVersion !== undefined && object.softwareVersion !== null
                ? VSoftwareVersion.fromPartial(object.softwareVersion)
                : undefined;
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? VSignature.fromPartial(object.signature)
                : undefined;
        return message;
    }
};
function createBaseVSoftwareVersion() {
    return {
        softwareVersionId: '',
        softwareFamily: '',
        version: '',
        downloadURL: '',
        isActive: false,
        isBeta: false,
        isRequired: false,
        updatedDTTM: undefined,
        creationDTTM: undefined
    };
}
export const VSoftwareVersion = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.softwareVersionId !== '') {
            writer.uint32(10).string(message.softwareVersionId);
        }
        if (message.softwareFamily !== '') {
            writer.uint32(18).string(message.softwareFamily);
        }
        if (message.version !== '') {
            writer.uint32(26).string(message.version);
        }
        if (message.downloadURL !== '') {
            writer.uint32(34).string(message.downloadURL);
        }
        if (message.isActive === true) {
            writer.uint32(40).bool(message.isActive);
        }
        if (message.isBeta === true) {
            writer.uint32(48).bool(message.isBeta);
        }
        if (message.isRequired === true) {
            writer.uint32(56).bool(message.isRequired);
        }
        if (message.updatedDTTM !== undefined) {
            VDateTime.encode(message.updatedDTTM, writer.uint32(66).fork()).ldelim();
        }
        if (message.creationDTTM !== undefined) {
            VDateTime.encode(message.creationDTTM, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVSoftwareVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.softwareVersionId = reader.string();
                    break;
                case 2:
                    message.softwareFamily = reader.string();
                    break;
                case 3:
                    message.version = reader.string();
                    break;
                case 4:
                    message.downloadURL = reader.string();
                    break;
                case 5:
                    message.isActive = reader.bool();
                    break;
                case 6:
                    message.isBeta = reader.bool();
                    break;
                case 7:
                    message.isRequired = reader.bool();
                    break;
                case 8:
                    message.updatedDTTM = VDateTime.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.creationDTTM = VDateTime.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            softwareVersionId: isSet(object.softwareVersionId)
                ? String(object.softwareVersionId)
                : '',
            softwareFamily: isSet(object.softwareFamily)
                ? String(object.softwareFamily)
                : '',
            version: isSet(object.version) ? String(object.version) : '',
            downloadURL: isSet(object.downloadURL) ? String(object.downloadURL) : '',
            isActive: isSet(object.isActive) ? Boolean(object.isActive) : false,
            isBeta: isSet(object.isBeta) ? Boolean(object.isBeta) : false,
            isRequired: isSet(object.isRequired) ? Boolean(object.isRequired) : false,
            updatedDTTM: isSet(object.updatedDTTM)
                ? VDateTime.fromJSON(object.updatedDTTM)
                : undefined,
            creationDTTM: isSet(object.creationDTTM)
                ? VDateTime.fromJSON(object.creationDTTM)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.softwareVersionId !== undefined &&
            (obj.softwareVersionId = message.softwareVersionId);
        message.softwareFamily !== undefined &&
            (obj.softwareFamily = message.softwareFamily);
        message.version !== undefined && (obj.version = message.version);
        message.downloadURL !== undefined &&
            (obj.downloadURL = message.downloadURL);
        message.isActive !== undefined && (obj.isActive = message.isActive);
        message.isBeta !== undefined && (obj.isBeta = message.isBeta);
        message.isRequired !== undefined && (obj.isRequired = message.isRequired);
        message.updatedDTTM !== undefined &&
            (obj.updatedDTTM = message.updatedDTTM
                ? VDateTime.toJSON(message.updatedDTTM)
                : undefined);
        message.creationDTTM !== undefined &&
            (obj.creationDTTM = message.creationDTTM
                ? VDateTime.toJSON(message.creationDTTM)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseVSoftwareVersion();
        message.softwareVersionId = (_a = object.softwareVersionId) !== null && _a !== void 0 ? _a : '';
        message.softwareFamily = (_b = object.softwareFamily) !== null && _b !== void 0 ? _b : '';
        message.version = (_c = object.version) !== null && _c !== void 0 ? _c : '';
        message.downloadURL = (_d = object.downloadURL) !== null && _d !== void 0 ? _d : '';
        message.isActive = (_e = object.isActive) !== null && _e !== void 0 ? _e : false;
        message.isBeta = (_f = object.isBeta) !== null && _f !== void 0 ? _f : false;
        message.isRequired = (_g = object.isRequired) !== null && _g !== void 0 ? _g : false;
        message.updatedDTTM =
            object.updatedDTTM !== undefined && object.updatedDTTM !== null
                ? VDateTime.fromPartial(object.updatedDTTM)
                : undefined;
        message.creationDTTM =
            object.creationDTTM !== undefined && object.creationDTTM !== null
                ? VDateTime.fromPartial(object.creationDTTM)
                : undefined;
        return message;
    }
};
function createBaseVStartEncryptRequest() {
    return { parentFileId: '', supportedEncryptionMethods: [] };
}
export const VStartEncryptRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.parentFileId !== '') {
            writer.uint32(10).string(message.parentFileId);
        }
        writer.uint32(18).fork();
        for (const v of message.supportedEncryptionMethods) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVStartEncryptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.parentFileId = reader.string();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.supportedEncryptionMethods.push(reader.int32());
                        }
                    }
                    else {
                        message.supportedEncryptionMethods.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            parentFileId: isSet(object.parentFileId)
                ? String(object.parentFileId)
                : '',
            supportedEncryptionMethods: Array.isArray(object === null || object === void 0 ? void 0 : object.supportedEncryptionMethods)
                ? object.supportedEncryptionMethods.map((e) => vEncryptionMethodsFromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.parentFileId !== undefined &&
            (obj.parentFileId = message.parentFileId);
        if (message.supportedEncryptionMethods) {
            obj.supportedEncryptionMethods = message.supportedEncryptionMethods.map((e) => vEncryptionMethodsToJSON(e));
        }
        else {
            obj.supportedEncryptionMethods = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVStartEncryptRequest();
        message.parentFileId = (_a = object.parentFileId) !== null && _a !== void 0 ? _a : '';
        message.supportedEncryptionMethods =
            ((_b = object.supportedEncryptionMethods) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    }
};
function createBaseVStartEncryptResponse() {
    return { response: undefined, fileId: '', serverSeed: undefined };
}
export const VStartEncryptResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.fileId !== '') {
            writer.uint32(18).string(message.fileId);
        }
        if (message.serverSeed !== undefined) {
            VServerSeed.encode(message.serverSeed, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVStartEncryptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.fileId = reader.string();
                    break;
                case 3:
                    message.serverSeed = VServerSeed.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            fileId: isSet(object.fileId) ? String(object.fileId) : '',
            serverSeed: isSet(object.serverSeed)
                ? VServerSeed.fromJSON(object.serverSeed)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.fileId !== undefined && (obj.fileId = message.fileId);
        message.serverSeed !== undefined &&
            (obj.serverSeed = message.serverSeed
                ? VServerSeed.toJSON(message.serverSeed)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVStartEncryptResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.fileId = (_a = object.fileId) !== null && _a !== void 0 ? _a : '';
        message.serverSeed =
            object.serverSeed !== undefined && object.serverSeed !== null
                ? VServerSeed.fromPartial(object.serverSeed)
                : undefined;
        return message;
    }
};
function createBaseVServerSeed() {
    return {
        seed: new Uint8Array(),
        iv: new Uint8Array(),
        bitwiseOperations: undefined,
        encryptionMethod: 0
    };
}
export const VServerSeed = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.seed.length !== 0) {
            writer.uint32(10).bytes(message.seed);
        }
        if (message.iv.length !== 0) {
            writer.uint32(18).bytes(message.iv);
        }
        if (message.bitwiseOperations !== undefined) {
            VBitwiseOperationList.encode(message.bitwiseOperations, writer.uint32(26).fork()).ldelim();
        }
        if (message.encryptionMethod !== 0) {
            writer.uint32(32).int32(message.encryptionMethod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVServerSeed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seed = reader.bytes();
                    break;
                case 2:
                    message.iv = reader.bytes();
                    break;
                case 3:
                    message.bitwiseOperations = VBitwiseOperationList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.encryptionMethod = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            seed: isSet(object.seed)
                ? bytesFromBase64(object.seed)
                : new Uint8Array(),
            iv: isSet(object.iv) ? bytesFromBase64(object.iv) : new Uint8Array(),
            bitwiseOperations: isSet(object.bitwiseOperations)
                ? VBitwiseOperationList.fromJSON(object.bitwiseOperations)
                : undefined,
            encryptionMethod: isSet(object.encryptionMethod)
                ? vEncryptionMethodsFromJSON(object.encryptionMethod)
                : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.seed !== undefined &&
            (obj.seed = base64FromBytes(message.seed !== undefined ? message.seed : new Uint8Array()));
        message.iv !== undefined &&
            (obj.iv = base64FromBytes(message.iv !== undefined ? message.iv : new Uint8Array()));
        message.bitwiseOperations !== undefined &&
            (obj.bitwiseOperations = message.bitwiseOperations
                ? VBitwiseOperationList.toJSON(message.bitwiseOperations)
                : undefined);
        message.encryptionMethod !== undefined &&
            (obj.encryptionMethod = vEncryptionMethodsToJSON(message.encryptionMethod));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVServerSeed();
        message.seed = (_a = object.seed) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.iv = (_b = object.iv) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.bitwiseOperations =
            object.bitwiseOperations !== undefined &&
                object.bitwiseOperations !== null
                ? VBitwiseOperationList.fromPartial(object.bitwiseOperations)
                : undefined;
        message.encryptionMethod = (_c = object.encryptionMethod) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function createBaseVTimeSpan() {
    return { hours: 0, minutes: 0, seconds: 0 };
}
export const VTimeSpan = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hours !== 0) {
            writer.uint32(8).int32(message.hours);
        }
        if (message.minutes !== 0) {
            writer.uint32(16).int32(message.minutes);
        }
        if (message.seconds !== 0) {
            writer.uint32(24).int32(message.seconds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVTimeSpan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hours = reader.int32();
                    break;
                case 2:
                    message.minutes = reader.int32();
                    break;
                case 3:
                    message.seconds = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hours: isSet(object.hours) ? Number(object.hours) : 0,
            minutes: isSet(object.minutes) ? Number(object.minutes) : 0,
            seconds: isSet(object.seconds) ? Number(object.seconds) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.hours !== undefined && (obj.hours = Math.round(message.hours));
        message.minutes !== undefined &&
            (obj.minutes = Math.round(message.minutes));
        message.seconds !== undefined &&
            (obj.seconds = Math.round(message.seconds));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVTimeSpan();
        message.hours = (_a = object.hours) !== null && _a !== void 0 ? _a : 0;
        message.minutes = (_b = object.minutes) !== null && _b !== void 0 ? _b : 0;
        message.seconds = (_c = object.seconds) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function createBaseVUpdateDevicePublicKeyRequest() {
    return { manufacturerPublicKey: '' };
}
export const VUpdateDevicePublicKeyRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.manufacturerPublicKey !== '') {
            writer.uint32(10).string(message.manufacturerPublicKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUpdateDevicePublicKeyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.manufacturerPublicKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            manufacturerPublicKey: isSet(object.manufacturerPublicKey)
                ? String(object.manufacturerPublicKey)
                : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.manufacturerPublicKey !== undefined &&
            (obj.manufacturerPublicKey = message.manufacturerPublicKey);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUpdateDevicePublicKeyRequest();
        message.manufacturerPublicKey = (_a = object.manufacturerPublicKey) !== null && _a !== void 0 ? _a : '';
        return message;
    }
};
function createBaseVUpdateDevicePublicKeyResponse() {
    return { response: undefined };
}
export const VUpdateDevicePublicKeyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUpdateDevicePublicKeyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVUpdateDevicePublicKeyResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVUserDetails() {
    return {
        userType: 0,
        firstName: '',
        lastName: '',
        details: [],
        licensing: undefined,
        capHash: new Uint8Array(),
        capCheckList: undefined
    };
}
export const VUserDetails = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.userType !== 0) {
            writer.uint32(8).int32(message.userType);
        }
        if (message.firstName !== '') {
            writer.uint32(18).string(message.firstName);
        }
        if (message.lastName !== '') {
            writer.uint32(26).string(message.lastName);
        }
        for (const v of message.details) {
            VUserDetails_VUserDetail.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.licensing !== undefined) {
            VUserLicensing.encode(message.licensing, writer.uint32(42).fork()).ldelim();
        }
        if (message.capHash.length !== 0) {
            writer.uint32(50).bytes(message.capHash);
        }
        if (message.capCheckList !== undefined) {
            CAPCheckList.encode(message.capCheckList, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userType = reader.int32();
                    break;
                case 2:
                    message.firstName = reader.string();
                    break;
                case 3:
                    message.lastName = reader.string();
                    break;
                case 4:
                    message.details.push(VUserDetails_VUserDetail.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.licensing = VUserLicensing.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.capHash = reader.bytes();
                    break;
                case 7:
                    message.capCheckList = CAPCheckList.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            userType: isSet(object.userType) ? vUserTypeFromJSON(object.userType) : 0,
            firstName: isSet(object.firstName) ? String(object.firstName) : '',
            lastName: isSet(object.lastName) ? String(object.lastName) : '',
            details: Array.isArray(object === null || object === void 0 ? void 0 : object.details)
                ? object.details.map((e) => VUserDetails_VUserDetail.fromJSON(e))
                : [],
            licensing: isSet(object.licensing)
                ? VUserLicensing.fromJSON(object.licensing)
                : undefined,
            capHash: isSet(object.capHash)
                ? bytesFromBase64(object.capHash)
                : new Uint8Array(),
            capCheckList: isSet(object.capCheckList)
                ? CAPCheckList.fromJSON(object.capCheckList)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.userType !== undefined &&
            (obj.userType = vUserTypeToJSON(message.userType));
        message.firstName !== undefined && (obj.firstName = message.firstName);
        message.lastName !== undefined && (obj.lastName = message.lastName);
        if (message.details) {
            obj.details = message.details.map((e) => e ? VUserDetails_VUserDetail.toJSON(e) : undefined);
        }
        else {
            obj.details = [];
        }
        message.licensing !== undefined &&
            (obj.licensing = message.licensing
                ? VUserLicensing.toJSON(message.licensing)
                : undefined);
        message.capHash !== undefined &&
            (obj.capHash = base64FromBytes(message.capHash !== undefined ? message.capHash : new Uint8Array()));
        message.capCheckList !== undefined &&
            (obj.capCheckList = message.capCheckList
                ? CAPCheckList.toJSON(message.capCheckList)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVUserDetails();
        message.userType = (_a = object.userType) !== null && _a !== void 0 ? _a : 0;
        message.firstName = (_b = object.firstName) !== null && _b !== void 0 ? _b : '';
        message.lastName = (_c = object.lastName) !== null && _c !== void 0 ? _c : '';
        message.details =
            ((_d = object.details) === null || _d === void 0 ? void 0 : _d.map((e) => VUserDetails_VUserDetail.fromPartial(e))) || [];
        message.licensing =
            object.licensing !== undefined && object.licensing !== null
                ? VUserLicensing.fromPartial(object.licensing)
                : undefined;
        message.capHash = (_e = object.capHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.capCheckList =
            object.capCheckList !== undefined && object.capCheckList !== null
                ? CAPCheckList.fromPartial(object.capCheckList)
                : undefined;
        return message;
    }
};
function createBaseVUserDetails_VUserDetail() {
    return { key: '', value: new Uint8Array(), dataType: 0 };
}
export const VUserDetails_VUserDetail = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.dataType !== 0) {
            writer.uint32(24).int32(message.dataType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserDetails_VUserDetail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.dataType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? String(object.key) : '',
            value: isSet(object.value)
                ? bytesFromBase64(object.value)
                : new Uint8Array(),
            dataType: isSet(object.dataType) ? vDataTypeFromJSON(object.dataType) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.dataType !== undefined &&
            (obj.dataType = vDataTypeToJSON(message.dataType));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVUserDetails_VUserDetail();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : '';
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.dataType = (_c = object.dataType) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function createBaseVUserLicensing() {
    return {
        licenseName: '',
        expirationDate: undefined,
        encryptsEnabled: false,
        genealogyEncryptsEnabled: false,
        decryptsEnabled: false,
        authoredDecryptsEnabled: false,
        decryptReceiptEmailsEnabled: false,
        decryptReceiptNotificationsEnabled: false,
        recallEnabled: false,
        shredEnabled: false,
        geofencingEnabled: false,
        userAccessModificationsEnabled: false,
        drmEnabled: false,
        capEnabled: false,
        classificationsEnabled: false,
        advancedReportingEnabled: false,
        advancedAnalyticsEnabled: false,
        isTrial: false,
        isLicenseUpgradeable: false,
        decryptBiometricsEnabled: false
    };
}
export const VUserLicensing = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.licenseName !== '') {
            writer.uint32(10).string(message.licenseName);
        }
        if (message.expirationDate !== undefined) {
            VDateTime.encode(message.expirationDate, writer.uint32(18).fork()).ldelim();
        }
        if (message.encryptsEnabled === true) {
            writer.uint32(24).bool(message.encryptsEnabled);
        }
        if (message.genealogyEncryptsEnabled === true) {
            writer.uint32(32).bool(message.genealogyEncryptsEnabled);
        }
        if (message.decryptsEnabled === true) {
            writer.uint32(40).bool(message.decryptsEnabled);
        }
        if (message.authoredDecryptsEnabled === true) {
            writer.uint32(48).bool(message.authoredDecryptsEnabled);
        }
        if (message.decryptReceiptEmailsEnabled === true) {
            writer.uint32(56).bool(message.decryptReceiptEmailsEnabled);
        }
        if (message.decryptReceiptNotificationsEnabled === true) {
            writer.uint32(64).bool(message.decryptReceiptNotificationsEnabled);
        }
        if (message.recallEnabled === true) {
            writer.uint32(72).bool(message.recallEnabled);
        }
        if (message.shredEnabled === true) {
            writer.uint32(80).bool(message.shredEnabled);
        }
        if (message.geofencingEnabled === true) {
            writer.uint32(88).bool(message.geofencingEnabled);
        }
        if (message.userAccessModificationsEnabled === true) {
            writer.uint32(96).bool(message.userAccessModificationsEnabled);
        }
        if (message.drmEnabled === true) {
            writer.uint32(104).bool(message.drmEnabled);
        }
        if (message.capEnabled === true) {
            writer.uint32(112).bool(message.capEnabled);
        }
        if (message.classificationsEnabled === true) {
            writer.uint32(120).bool(message.classificationsEnabled);
        }
        if (message.advancedReportingEnabled === true) {
            writer.uint32(128).bool(message.advancedReportingEnabled);
        }
        if (message.advancedAnalyticsEnabled === true) {
            writer.uint32(136).bool(message.advancedAnalyticsEnabled);
        }
        if (message.isTrial === true) {
            writer.uint32(144).bool(message.isTrial);
        }
        if (message.isLicenseUpgradeable === true) {
            writer.uint32(152).bool(message.isLicenseUpgradeable);
        }
        if (message.decryptBiometricsEnabled === true) {
            writer.uint32(160).bool(message.decryptBiometricsEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserLicensing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.licenseName = reader.string();
                    break;
                case 2:
                    message.expirationDate = VDateTime.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.encryptsEnabled = reader.bool();
                    break;
                case 4:
                    message.genealogyEncryptsEnabled = reader.bool();
                    break;
                case 5:
                    message.decryptsEnabled = reader.bool();
                    break;
                case 6:
                    message.authoredDecryptsEnabled = reader.bool();
                    break;
                case 7:
                    message.decryptReceiptEmailsEnabled = reader.bool();
                    break;
                case 8:
                    message.decryptReceiptNotificationsEnabled = reader.bool();
                    break;
                case 9:
                    message.recallEnabled = reader.bool();
                    break;
                case 10:
                    message.shredEnabled = reader.bool();
                    break;
                case 11:
                    message.geofencingEnabled = reader.bool();
                    break;
                case 12:
                    message.userAccessModificationsEnabled = reader.bool();
                    break;
                case 13:
                    message.drmEnabled = reader.bool();
                    break;
                case 14:
                    message.capEnabled = reader.bool();
                    break;
                case 15:
                    message.classificationsEnabled = reader.bool();
                    break;
                case 16:
                    message.advancedReportingEnabled = reader.bool();
                    break;
                case 17:
                    message.advancedAnalyticsEnabled = reader.bool();
                    break;
                case 18:
                    message.isTrial = reader.bool();
                    break;
                case 19:
                    message.isLicenseUpgradeable = reader.bool();
                    break;
                case 20:
                    message.decryptBiometricsEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            licenseName: isSet(object.licenseName) ? String(object.licenseName) : '',
            expirationDate: isSet(object.expirationDate)
                ? VDateTime.fromJSON(object.expirationDate)
                : undefined,
            encryptsEnabled: isSet(object.encryptsEnabled)
                ? Boolean(object.encryptsEnabled)
                : false,
            genealogyEncryptsEnabled: isSet(object.genealogyEncryptsEnabled)
                ? Boolean(object.genealogyEncryptsEnabled)
                : false,
            decryptsEnabled: isSet(object.decryptsEnabled)
                ? Boolean(object.decryptsEnabled)
                : false,
            authoredDecryptsEnabled: isSet(object.authoredDecryptsEnabled)
                ? Boolean(object.authoredDecryptsEnabled)
                : false,
            decryptReceiptEmailsEnabled: isSet(object.decryptReceiptEmailsEnabled)
                ? Boolean(object.decryptReceiptEmailsEnabled)
                : false,
            decryptReceiptNotificationsEnabled: isSet(object.decryptReceiptNotificationsEnabled)
                ? Boolean(object.decryptReceiptNotificationsEnabled)
                : false,
            recallEnabled: isSet(object.recallEnabled)
                ? Boolean(object.recallEnabled)
                : false,
            shredEnabled: isSet(object.shredEnabled)
                ? Boolean(object.shredEnabled)
                : false,
            geofencingEnabled: isSet(object.geofencingEnabled)
                ? Boolean(object.geofencingEnabled)
                : false,
            userAccessModificationsEnabled: isSet(object.userAccessModificationsEnabled)
                ? Boolean(object.userAccessModificationsEnabled)
                : false,
            drmEnabled: isSet(object.drmEnabled) ? Boolean(object.drmEnabled) : false,
            capEnabled: isSet(object.capEnabled) ? Boolean(object.capEnabled) : false,
            classificationsEnabled: isSet(object.classificationsEnabled)
                ? Boolean(object.classificationsEnabled)
                : false,
            advancedReportingEnabled: isSet(object.advancedReportingEnabled)
                ? Boolean(object.advancedReportingEnabled)
                : false,
            advancedAnalyticsEnabled: isSet(object.advancedAnalyticsEnabled)
                ? Boolean(object.advancedAnalyticsEnabled)
                : false,
            isTrial: isSet(object.isTrial) ? Boolean(object.isTrial) : false,
            isLicenseUpgradeable: isSet(object.isLicenseUpgradeable)
                ? Boolean(object.isLicenseUpgradeable)
                : false,
            decryptBiometricsEnabled: isSet(object.decryptBiometricsEnabled)
                ? Boolean(object.decryptBiometricsEnabled)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.licenseName !== undefined &&
            (obj.licenseName = message.licenseName);
        message.expirationDate !== undefined &&
            (obj.expirationDate = message.expirationDate
                ? VDateTime.toJSON(message.expirationDate)
                : undefined);
        message.encryptsEnabled !== undefined &&
            (obj.encryptsEnabled = message.encryptsEnabled);
        message.genealogyEncryptsEnabled !== undefined &&
            (obj.genealogyEncryptsEnabled = message.genealogyEncryptsEnabled);
        message.decryptsEnabled !== undefined &&
            (obj.decryptsEnabled = message.decryptsEnabled);
        message.authoredDecryptsEnabled !== undefined &&
            (obj.authoredDecryptsEnabled = message.authoredDecryptsEnabled);
        message.decryptReceiptEmailsEnabled !== undefined &&
            (obj.decryptReceiptEmailsEnabled = message.decryptReceiptEmailsEnabled);
        message.decryptReceiptNotificationsEnabled !== undefined &&
            (obj.decryptReceiptNotificationsEnabled =
                message.decryptReceiptNotificationsEnabled);
        message.recallEnabled !== undefined &&
            (obj.recallEnabled = message.recallEnabled);
        message.shredEnabled !== undefined &&
            (obj.shredEnabled = message.shredEnabled);
        message.geofencingEnabled !== undefined &&
            (obj.geofencingEnabled = message.geofencingEnabled);
        message.userAccessModificationsEnabled !== undefined &&
            (obj.userAccessModificationsEnabled =
                message.userAccessModificationsEnabled);
        message.drmEnabled !== undefined && (obj.drmEnabled = message.drmEnabled);
        message.capEnabled !== undefined && (obj.capEnabled = message.capEnabled);
        message.classificationsEnabled !== undefined &&
            (obj.classificationsEnabled = message.classificationsEnabled);
        message.advancedReportingEnabled !== undefined &&
            (obj.advancedReportingEnabled = message.advancedReportingEnabled);
        message.advancedAnalyticsEnabled !== undefined &&
            (obj.advancedAnalyticsEnabled = message.advancedAnalyticsEnabled);
        message.isTrial !== undefined && (obj.isTrial = message.isTrial);
        message.isLicenseUpgradeable !== undefined &&
            (obj.isLicenseUpgradeable = message.isLicenseUpgradeable);
        message.decryptBiometricsEnabled !== undefined &&
            (obj.decryptBiometricsEnabled = message.decryptBiometricsEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const message = createBaseVUserLicensing();
        message.licenseName = (_a = object.licenseName) !== null && _a !== void 0 ? _a : '';
        message.expirationDate =
            object.expirationDate !== undefined && object.expirationDate !== null
                ? VDateTime.fromPartial(object.expirationDate)
                : undefined;
        message.encryptsEnabled = (_b = object.encryptsEnabled) !== null && _b !== void 0 ? _b : false;
        message.genealogyEncryptsEnabled = (_c = object.genealogyEncryptsEnabled) !== null && _c !== void 0 ? _c : false;
        message.decryptsEnabled = (_d = object.decryptsEnabled) !== null && _d !== void 0 ? _d : false;
        message.authoredDecryptsEnabled = (_e = object.authoredDecryptsEnabled) !== null && _e !== void 0 ? _e : false;
        message.decryptReceiptEmailsEnabled =
            (_f = object.decryptReceiptEmailsEnabled) !== null && _f !== void 0 ? _f : false;
        message.decryptReceiptNotificationsEnabled =
            (_g = object.decryptReceiptNotificationsEnabled) !== null && _g !== void 0 ? _g : false;
        message.recallEnabled = (_h = object.recallEnabled) !== null && _h !== void 0 ? _h : false;
        message.shredEnabled = (_j = object.shredEnabled) !== null && _j !== void 0 ? _j : false;
        message.geofencingEnabled = (_k = object.geofencingEnabled) !== null && _k !== void 0 ? _k : false;
        message.userAccessModificationsEnabled =
            (_l = object.userAccessModificationsEnabled) !== null && _l !== void 0 ? _l : false;
        message.drmEnabled = (_m = object.drmEnabled) !== null && _m !== void 0 ? _m : false;
        message.capEnabled = (_o = object.capEnabled) !== null && _o !== void 0 ? _o : false;
        message.classificationsEnabled = (_p = object.classificationsEnabled) !== null && _p !== void 0 ? _p : false;
        message.advancedReportingEnabled = (_q = object.advancedReportingEnabled) !== null && _q !== void 0 ? _q : false;
        message.advancedAnalyticsEnabled = (_r = object.advancedAnalyticsEnabled) !== null && _r !== void 0 ? _r : false;
        message.isTrial = (_s = object.isTrial) !== null && _s !== void 0 ? _s : false;
        message.isLicenseUpgradeable = (_t = object.isLicenseUpgradeable) !== null && _t !== void 0 ? _t : false;
        message.decryptBiometricsEnabled = (_u = object.decryptBiometricsEnabled) !== null && _u !== void 0 ? _u : false;
        return message;
    }
};
function createBaseVUserGeofencingCitiesRequest() {
    return { territoryId: 0 };
}
export const VUserGeofencingCitiesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.territoryId !== 0) {
            writer.uint32(8).int64(message.territoryId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingCitiesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.territoryId = longToNumber(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            territoryId: isSet(object.territoryId) ? Number(object.territoryId) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.territoryId !== undefined &&
            (obj.territoryId = Math.round(message.territoryId));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserGeofencingCitiesRequest();
        message.territoryId = (_a = object.territoryId) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVUserGeofencingCitiesResponse() {
    return { response: undefined, cities: [] };
}
export const VUserGeofencingCitiesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.cities) {
            VGeoCity.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingCitiesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.cities.push(VGeoCity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            cities: Array.isArray(object === null || object === void 0 ? void 0 : object.cities)
                ? object.cities.map((e) => VGeoCity.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        if (message.cities) {
            obj.cities = message.cities.map((e) => e ? VGeoCity.toJSON(e) : undefined);
        }
        else {
            obj.cities = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserGeofencingCitiesResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.cities = ((_a = object.cities) === null || _a === void 0 ? void 0 : _a.map((e) => VGeoCity.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVUserGeofencingCountriesRequest() {
    return {};
}
export const VUserGeofencingCountriesRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingCountriesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseVUserGeofencingCountriesRequest();
        return message;
    }
};
function createBaseVUserGeofencingCountriesResponse() {
    return { response: undefined, countries: [] };
}
export const VUserGeofencingCountriesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.countries) {
            VGeoCountry.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingCountriesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.countries.push(VGeoCountry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            countries: Array.isArray(object === null || object === void 0 ? void 0 : object.countries)
                ? object.countries.map((e) => VGeoCountry.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        if (message.countries) {
            obj.countries = message.countries.map((e) => e ? VGeoCountry.toJSON(e) : undefined);
        }
        else {
            obj.countries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserGeofencingCountriesResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.countries =
            ((_a = object.countries) === null || _a === void 0 ? void 0 : _a.map((e) => VGeoCountry.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVUserGeofencingTerritoriesRequest() {
    return { countryId: 0 };
}
export const VUserGeofencingTerritoriesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.countryId !== 0) {
            writer.uint32(8).int32(message.countryId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingTerritoriesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.countryId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            countryId: isSet(object.countryId) ? Number(object.countryId) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.countryId !== undefined &&
            (obj.countryId = Math.round(message.countryId));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserGeofencingTerritoriesRequest();
        message.countryId = (_a = object.countryId) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function createBaseVUserGeofencingTerritoriesResponse() {
    return { response: undefined, territories: [] };
}
export const VUserGeofencingTerritoriesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.territories) {
            VGeoTerritory.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserGeofencingTerritoriesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.territories.push(VGeoTerritory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            territories: Array.isArray(object === null || object === void 0 ? void 0 : object.territories)
                ? object.territories.map((e) => VGeoTerritory.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        if (message.territories) {
            obj.territories = message.territories.map((e) => e ? VGeoTerritory.toJSON(e) : undefined);
        }
        else {
            obj.territories = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserGeofencingTerritoriesResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.territories =
            ((_a = object.territories) === null || _a === void 0 ? void 0 : _a.map((e) => VGeoTerritory.fromPartial(e))) || [];
        return message;
    }
};
function createBaseVUserExistRequest() {
    return { userId: [] };
}
export const VUserExistRequest = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.userId) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserExistRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            userId: Array.isArray(object === null || object === void 0 ? void 0 : object.userId)
                ? object.userId.map((e) => String(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.userId) {
            obj.userId = message.userId.map((e) => e);
        }
        else {
            obj.userId = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserExistRequest();
        message.userId = ((_a = object.userId) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    }
};
function createBaseVUserExists() {
    return { userId: '', exists: false, method: 0, emailConfirmed: false };
}
export const VUserExists = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.userId !== '') {
            writer.uint32(10).string(message.userId);
        }
        if (message.exists === true) {
            writer.uint32(16).bool(message.exists);
        }
        if (message.method !== 0) {
            writer.uint32(24).int32(message.method);
        }
        if (message.emailConfirmed === true) {
            writer.uint32(32).bool(message.emailConfirmed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserExists();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId = reader.string();
                    break;
                case 2:
                    message.exists = reader.bool();
                    break;
                case 3:
                    message.method = reader.int32();
                    break;
                case 4:
                    message.emailConfirmed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            userId: isSet(object.userId) ? String(object.userId) : '',
            exists: isSet(object.exists) ? Boolean(object.exists) : false,
            method: isSet(object.method) ? vLoginMethodFromJSON(object.method) : 0,
            emailConfirmed: isSet(object.emailConfirmed)
                ? Boolean(object.emailConfirmed)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.userId !== undefined && (obj.userId = message.userId);
        message.exists !== undefined && (obj.exists = message.exists);
        message.method !== undefined &&
            (obj.method = vLoginMethodToJSON(message.method));
        message.emailConfirmed !== undefined &&
            (obj.emailConfirmed = message.emailConfirmed);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseVUserExists();
        message.userId = (_a = object.userId) !== null && _a !== void 0 ? _a : '';
        message.exists = (_b = object.exists) !== null && _b !== void 0 ? _b : false;
        message.method = (_c = object.method) !== null && _c !== void 0 ? _c : 0;
        message.emailConfirmed = (_d = object.emailConfirmed) !== null && _d !== void 0 ? _d : false;
        return message;
    }
};
function createBaseVUserExistResponse() {
    return { userExistList: [], response: undefined };
}
export const VUserExistResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.userExistList) {
            VUserExists.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserExistResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userExistList.push(VUserExists.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            userExistList: Array.isArray(object === null || object === void 0 ? void 0 : object.userExistList)
                ? object.userExistList.map((e) => VUserExists.fromJSON(e))
                : [],
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.userExistList) {
            obj.userExistList = message.userExistList.map((e) => e ? VUserExists.toJSON(e) : undefined);
        }
        else {
            obj.userExistList = [];
        }
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVUserExistResponse();
        message.userExistList =
            ((_a = object.userExistList) === null || _a === void 0 ? void 0 : _a.map((e) => VUserExists.fromPartial(e))) || [];
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVUserRegisterRequest() {
    return { email: '', password: '', firstName: '', lastName: '' };
}
export const VUserRegisterRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.email !== '') {
            writer.uint32(10).string(message.email);
        }
        if (message.password !== '') {
            writer.uint32(18).string(message.password);
        }
        if (message.firstName !== '') {
            writer.uint32(26).string(message.firstName);
        }
        if (message.lastName !== '') {
            writer.uint32(34).string(message.lastName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserRegisterRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                case 2:
                    message.password = reader.string();
                    break;
                case 3:
                    message.firstName = reader.string();
                    break;
                case 4:
                    message.lastName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            email: isSet(object.email) ? String(object.email) : '',
            password: isSet(object.password) ? String(object.password) : '',
            firstName: isSet(object.firstName) ? String(object.firstName) : '',
            lastName: isSet(object.lastName) ? String(object.lastName) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.email !== undefined && (obj.email = message.email);
        message.password !== undefined && (obj.password = message.password);
        message.firstName !== undefined && (obj.firstName = message.firstName);
        message.lastName !== undefined && (obj.lastName = message.lastName);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseVUserRegisterRequest();
        message.email = (_a = object.email) !== null && _a !== void 0 ? _a : '';
        message.password = (_b = object.password) !== null && _b !== void 0 ? _b : '';
        message.firstName = (_c = object.firstName) !== null && _c !== void 0 ? _c : '';
        message.lastName = (_d = object.lastName) !== null && _d !== void 0 ? _d : '';
        return message;
    }
};
function createBaseVUserRegisterResponse() {
    return { response: undefined };
}
export const VUserRegisterResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserRegisterResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVUserRegisterResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        return message;
    }
};
function createBaseVUserDetailsRequest() {
    return { includeCAP: false, capHash: new Uint8Array() };
}
export const VUserDetailsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.includeCAP === true) {
            writer.uint32(8).bool(message.includeCAP);
        }
        if (message.capHash.length !== 0) {
            writer.uint32(18).bytes(message.capHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserDetailsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.includeCAP = reader.bool();
                    break;
                case 2:
                    message.capHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            includeCAP: isSet(object.includeCAP) ? Boolean(object.includeCAP) : false,
            capHash: isSet(object.capHash)
                ? bytesFromBase64(object.capHash)
                : new Uint8Array()
        };
    },
    toJSON(message) {
        const obj = {};
        message.includeCAP !== undefined && (obj.includeCAP = message.includeCAP);
        message.capHash !== undefined &&
            (obj.capHash = base64FromBytes(message.capHash !== undefined ? message.capHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVUserDetailsRequest();
        message.includeCAP = (_a = object.includeCAP) !== null && _a !== void 0 ? _a : false;
        message.capHash = (_b = object.capHash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function createBaseVUserDetailsResponse() {
    return { response: undefined, userDetails: undefined };
}
export const VUserDetailsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.response !== undefined) {
            VResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.userDetails !== undefined) {
            VUserDetails.encode(message.userDetails, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVUserDetailsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = VResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.userDetails = VUserDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response)
                ? VResponse.fromJSON(object.response)
                : undefined,
            userDetails: isSet(object.userDetails)
                ? VUserDetails.fromJSON(object.userDetails)
                : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.response !== undefined &&
            (obj.response = message.response
                ? VResponse.toJSON(message.response)
                : undefined);
        message.userDetails !== undefined &&
            (obj.userDetails = message.userDetails
                ? VUserDetails.toJSON(message.userDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVUserDetailsResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? VResponse.fromPartial(object.response)
                : undefined;
        message.userDetails =
            object.userDetails !== undefined && object.userDetails !== null
                ? VUserDetails.fromPartial(object.userDetails)
                : undefined;
        return message;
    }
};
var globalThis = (() => {
    if (typeof globalThis !== 'undefined')
        return globalThis;
    if (typeof self !== 'undefined')
        return self;
    if (typeof window !== 'undefined')
        return window;
    if (typeof global !== 'undefined')
        return global;
    throw 'Unable to locate global object';
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString('base64');
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(''));
    }
}
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER');
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
